(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./blogs/blogs.module": [
		"./src/app/blogs/blogs.module.ts",
		"common",
		"blogs-blogs-module"
	],
	"./cart/cart.module": [
		"./src/app/cart/cart.module.ts",
		"default~cart-cart-module~my-account-my-account-module",
		"cart-cart-module"
	],
	"./my-account/my-account.module": [
		"./src/app/my-account/my-account.module.ts",
		"default~cart-cart-module~my-account-my-account-module",
		"my-account-my-account-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	],
	"./posts/posts.module": [
		"./src/app/posts/posts.module.ts",
		"posts-posts-module"
	],
	"./products/products.module": [
		"./src/app/products/products.module.ts",
		"common",
		"products-products-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ng-progress></ng-progress>\n<app-header></app-header>\n<app-layout></app-layout>\n<app-footer></app-footer>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/layout/layout.component.html":
/*!************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/layout/layout.component.html ***!
  \************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/page-not-found/page-not-found.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/pages/page-not-found/page-not-found.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<section class=\"pg-404\"> \n\t<div class=\" div-float\">\n\t\t<img src=\"assets/images/404.png\" alt=\"404\" class=\"img-fluid\" />\n\t\t<h1>Page Not Found</h1>\n\t\t<a routerLink=\"\" class=\"btn-shop float-none\">BACK TO HOMEPAGE</a>\n\t</div>\n</section>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/search-details/search-details.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/search-details/search-details.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- content starts -->\n<section class=\"main-ship div-float\">\n        <div class=\"container-fluid\">\n            <div class=\"wrapper\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <ul class=\"breadcrumb bb\">\n                          <li><a href=\"index.php\">Home</a></li>\n                          <li><a href=\"javascript:void(0)\">Search Results</a></li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </section>\n\n\n    <section class=\"prf-lwr-sec\"  *ngIf=\"searchRecords.length > 0\">\n       <div class=\"container-fluid\">\n            <div class=\"wrapper\">\n                <!-- <div class=\"row\" *ngIf=\"searchRecords.length > 1\">\n                    <div class=\"col-md-12\">\n                        <div class=\"srch-tp-dd div-float\">\n                            <div class=\"pro-list-dropdown\">\n                                <span>SORT BY</span>\n                                 <select (change)=\"sort($event)\">\n                                     <option value=\"\">Select</option>\n                                     <option value=\"low_to_high\">Low to High</option>\n                                     <option value=\"high_to_low\">High to Low</option>\n                                 </select>\n                            </div>\n                        </div>\n                    </div>\n                </div> -->\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                         <div class=\"search-detail-main div-float\">\n                                 <div class=\"search-det\" *ngFor=\"let product of searchRecords\">\n                                     <div class=\"wish-pro div-float\">\n                                         <div class=\"wish-img\">\n                                            <a [href]=\"product.link\">\n                                                <img [src]=\"product.image\" [alt]=\"product.name\"  />\n                                            </a>\n                                         </div>\n                                         <div class=\"wish-txt\">\n                                             <h4> <a style=\"color:black\" [href]=\"product.link\">{{ product.name }}</a></h4>\n                                             <!-- <p [innerHTML]=\"product.content\"></p> -->\n                                             <!-- <app-product-price [product]=\"product.dataPoints[0]\"></app-product-price> -->\n                                         </div>\n                                     </div>\n                                 </div>\n                         </div>\n                     </div>\n                 </div>\n             </div>\n         </div>\n    </section>\n\n<div class=\"srch-prdt text-center\">\n    <app-not-found *ngIf=\"searchRecords && !searchRecords.length\" [text]=\"'SORRY, NO RESULTS FOUND'\"></app-not-found>\n</div>\n\n\n<!-- content ends -->\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/category/category.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/category/category.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row imghovr\" *ngIf=\"categories.length > 0\">\n    <div class=\"col-12 col-sm-6 col-md-3 mb-3\" *ngFor=\"let category of categories\">\n        <a [routerLink]=\"[link, category.slug]\" (click)=\"productListing(category)\" >\n            <div class=\"category-img\">\n                <table>\n                    <tr>\n                        <td>\n                            <img src=\"{{ category?.image_url | imageUrl }}\" alt=\"{{ category.name }}\" />\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class=\"cat-content\">\n                <p>{{ category.name }}</p>\n                <!-- <img src=\"/assets/images/cat-icon.png\" alt=\"Price Tag\" /> -->\n            </div>\n        </a>\n    </div>\n</div>\n<div class=\"col-md-12\" *ngIf=\"viewMoreLink\">\n    <div class=\"show-more div-float text-center pt-5\"> \n         <button class=\"btn1 vm-btn mb-0\" type=\"button\" routerLink=\"/{{viewMoreLink}}\"> VIEW MORE </button>\n    </div>\n</div>\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/contact-form/contact-form.component.html":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/contact-form/contact-form.component.html ***!
  \******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"contact-form\">\n    <form [formGroup]=\"form\" (ngSubmit)=\"submit(form.value)\" novalidate>\n        <div class=\"contact-form-fields\">\n            <div class=\"contact-form-label\">\n                <label>Name</label>\n            </div>\n            <div class=\"contact-field\">\n                <input type=\"text\" name=\"\" class=\"qa-name\" formControlName=\"name\" />\n            </div>\n            <div class=\"error-block\" *ngIf=\"!form.get('name').valid && (form.get('name').dirty || form.get('name').touched)\">This field is required.</div>\n        </div>\n\n        <div class=\"contact-form-fields\">\n            <div class=\"contact-form-label\">\n                <label>Email address</label>\n            </div>\n            <div class=\"contact-field\">\n                <input type=\"text\" name=\"email\" class=\"qa-email\" formControlName=\"email\" />\n            </div>\n            <div class=\"error-block\" *ngIf=\"form.get('email').hasError('required') && (form.get('email').dirty || form.get('email').touched)\">This field is required.</div>\n            <div class=\"error-block\" *ngIf=\"form.get('email').hasError('email') && (form.get('email').dirty || form.get('email').touched)\">Email is invalid.</div>\n        </div>\n\n        <div class=\"contact-form-fields\">\n            <div class=\"contact-form-label\">\n                <label>Subject</label>\n            </div>\n            <div class=\"contact-field\">\n                <input type=\"text\" name=\"subject\" class=\"qa-subject\" formControlName=\"subject\" />\n            </div>\n            <div class=\"error-block\" *ngIf=\"!form.get('subject').valid && (form.get('name').dirty || form.get('subject').touched)\">This field is required.</div>\n        </div>\n\n        <div class=\"contact-form-fields\">\n            <div class=\"contact-form-label\">\n                <label>Message</label>\n            </div>\n            <div class=\"contact-field\">\n                <textarea class=\"qa-textarea\" name=\"message\" formControlName=\"message\"></textarea>\n            </div>\n            <div class=\"error-block\" *ngIf=\"!form.get('message').valid && (form.get('message').dirty || form.get('message').touched)\">This field is required.</div>\n        </div>\n        <div class=\"contact-btn\">\n            <button class=\"btn1 qa-btn\" type=\"submit\" [disabled]=\"disableSubmit\">SUBMIT</button>\n        </div>\n    </form>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/faq/faq.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/faq/faq.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"shipping-descrip div-float\">\n    <div class=\"row faqRow\" *ngFor=\"let faq of faqs\">\n        <div class=\"col-md-12 mb-2 mt-2\">\n            <h3 class=\"faq\">{{ faq.question }}</h3>\n            <p class=\"faqq\" [innerHTML]=\"faq.answer | sanitizeHTML\">}</p>\n        </div>\n    </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/forgot-password/forgot-password.component.html":
/*!************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/forgot-password/forgot-password.component.html ***!
  \************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (" <!-- The Modal -->\n <div class=\"modal\" id=\"forgot\" #modal>\n    <div class=\"modal-dialog forgot-model\">\n        <div class=\"modal-content forgot-content\">\n        \n        <!-- Modal Header -->\n        <div class=\"modal-header pop-head\"> \n            <button type=\"button\" class=\"close cut\" data-dismiss=\"modal\">x</button>\n        </div>\n        \n        <!-- Modal body -->\n        <div class=\"modal-body pop-body\">\n            <h1>REQUEST TO RESET YOUR PASSWORD</h1>\n            <p>Provide your account email address to receive an email to reset your password.</p>\n\n            <form  [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form.value)\" novalidate>\n                <div class=\"contact-form-fields\">\n                    <div class=\"contact-form-label\">\n                        <label>Email address *</label>\n                    </div>\n                    <div class=\"contact-field\">\n                        <input type=\"text\" name=\"email\" formControlName=\"email\"  />\n                    </div>\n                    <div class=\"error-block\" *ngIf=\"form.get('email').hasError('required') && (form.get('email').dirty || form.get('email').touched)\">This field is required.</div>\n                    <div class=\"error-block\" *ngIf=\"form.get('email').hasError('email') && (form.get('email').dirty || form.get('email').touched)\">Email is invalid.</div>\n                </div>\n\n                <div class=\"contact-btn\">\n                    <button class=\"btn1 btn4\" type=\"submit\">REQUEST</button>\n                </div>\n            </form>\n        </div> \n        \n        </div>\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/login-form/login-form.component.html":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/login-form/login-form.component.html ***!
  \**************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form.value)\">\n        <div class=\"form-group\">\n            <label>Email address</label>\n            <input type=\"email\" class=\"inpt-full logn-email form-control qa-email\" name=\"email\" formControlName=\"email\">\n            <div class=\"error-block\" *ngIf=\"form.get('email').hasError('required') && (form.get('email').dirty || form.get('email').touched)\">This field is required.</div>\n            <div class=\"error-block\" *ngIf=\"form.get('email').hasError('email') && (form.get('email').dirty || form.get('email').touched)\">Email is invalid.</div>\n        </div>\n\n        <div class=\"form-group\">\n            <label>Password</label>\n            <input type=\"password\" class=\"inpt-full logn-paswrd qa-pwd form-control\" name=\"pswd\" formControlName=\"password\">\n            <div class=\"error-block\" *ngIf=\"form.get('password').hasError('required') && (form.get('password').dirty || form.get('password').touched)\">This field is required.</div>\n            <a href=\"#\" class=\"crt-frgt\" data-toggle=\"modal\" data-target=\"#forgot\">Forgot Password?</a>\n        </div>\n\n        <div class=\"crt-keep\">\n            <label class=\"keep-sngd\">\n            <input type=\"checkbox\" class=\"qa-check\">\n            <span class=\"cart-chk\"></span>\n            </label>\n            <p>Keep me signed in</p>\n        </div>\n\n        <div class=\"form-group ctrbtn\">\n            <button class=\"btn-shop2 qa-btn\" type=\"submit\">Login</button>\n        </div>\n</form>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/login-popup/login-popup.component.html":
/*!****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/login-popup/login-popup.component.html ***!
  \****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"login-form\">\n    <form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form.value)\">\n    <h1>Returning Customers</h1>\n    <div class=\"contact-form-fields\">\n        <div class=\"contact-form-label\">\n            <label>Email address</label>\n        </div>\n        <div class=\"contact-field account-field\">\n            <input type=\"text\" name=\"email\" formControlName=\"email\"  />\n            <div class=\"error-block\" *ngIf=\"form.get('email').hasError('required') && (form.get('email').dirty || form.get('email').touched)\">This field is required.</div>\n            <div class=\"error-block\" *ngIf=\"form.get('email').hasError('email') && (form.get('email').dirty || form.get('email').touched)\">Email is invalid.</div>\n\n        </div>\n        \n    </div>\n    <div class=\"contact-form-fields login-field\">\n        <div class=\"contact-form-label\">\n            <label>Password</label>\n        </div>\n        <div class=\"contact-field account-field \">\n            <input type=\"password\" name=\"password\" formControlName=\"password\"  />\n            <div class=\"error-block\" *ngIf=\"form.get('password').hasError('required') && (form.get('password').dirty || form.get('password').touched)\">This field is required.</div>\n        </div>\n        <a href=\"#\" data-toggle=\"modal\" data-target=\"#forgot\" id=\"forgotLink\">Forgot Password?</a>\n    </div>\n    <div class=\"contact-btn\">\n        <button class=\"btn1 btn3\" type=\"submit\">SIGN IN</button>\n    </div>\n    <div class=\"lrs\">\n        <hr>\n        <span>NEW CUSTOMERS? </span>\n        <a routerLink=\"/register\" class=\"profile-btn\">Click Here</a>\n    </div>\n        <!-- <div class=\"contact-btn\">\n            <button class=\"btn1 btn3\" type=\"submit\">CREATE AN ACCOUNT</button>\n        </div> -->\n    </form>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/not-found/not-found.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/not-found/not-found.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"not_found\">{{ text }}</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/order-summary/order-summary.component.html":
/*!********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/order-summary/order-summary.component.html ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"order-sum\">\n    <table class=\"table order-sum-tbl-1\">\n        <thead class=\"fh_bor\">\n            <tr>\n                <th style=\"width: 60%; \">Order Summary</th>\n                <th style=\"width: 20%; \">Qty</th>\n                <th style=\"width: 20%; \">Price</th>\n            </tr>\n        </thead>\n\n\n        <tr *ngFor=\"let item of order.products\">\n\n          <td colspan=\"3\">\n\n            <table class=\"table order-sum-tbl-1\">\n              <colgroup>\n                <col width=\"60%\" />\n                <col width=\"20%\" />\n                <col width=\"20%\" />\n              </colgroup>\n              <tr>\n\n                <td>\n                    <div class=\"pro-info div-float\">\n                        <div class=\"pro-info-img\">\n                            <table>\n                                <tr>\n                                    <td>\n                                        <img src=\"{{ item.product.image_full_url | imageUrl }}\"\n                                            alt=\"{{ item.product.name }}\" />\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                        <div class=\"pro-info-txt text-left\">\n                            <h6>{{ item.product.name }} </h6>\n                            <p>{{ item.product.short_description }}</p>\n                            <ng-template [ngIf]=\"item.options && item.options?.length > 0\">\n                                <app-product-options [options]=\"item.options\"></app-product-options>\n                            </ng-template>\n\n                            <!--\n                            <ng-template [ngIf]=\"item?.engraving_option\">\n                                <div class=\"clearfix\"></div>\n                                <hr />\n                                <h6>Customization Options:</h6>\n                                <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.interlocking_option\">\n\n                                  <div class=\"col-md-12\">\n                                    <h6>Interlocking:</h6>\n\n                                    <div class=\"row\">\n                                      <div class=\"col-6 text-left\">\n                                        <label>Interlocking Metal Color:</label>\n                                      </div>\n                                      <div class=\"col-6 text-left\">\n                                        <p>{{ item?.engraving_option?.interlocking_option.variant }}</p>\n                                      </div>\n                                    </div>\n                                  </div>\n\n                                </div>\n\n                                <div class=\"row bxtxt-mid dangles\" *ngIf=\"item?.engraving_option?.dangles\">\n\n                                  <div class=\"col-md-12\">\n                                    <h6>Dangles:</h6>\n                                    <div class=\"row\">\n                                      <div class=\"col-4 text-left\">\n                                        <label>Quantity:</label>\n                                      </div>\n                                      <div class=\"col-8 text-left\">\n                                        <p>{{ item?.engraving_option?.dangles.quantity }}</p>\n                                      </div>\n                                    </div>\n\n                                    <div class=\"row\">\n                                      <div class=\"col-4 text-left\">\n                                        <label>Type:</label>\n                                      </div>\n\n                                      <div class=\"col-8 text-left\">\n                                        <p>{{ item?.engraving_option?.dangles.type }}</p>\n                                      </div>\n                                    </div>\n\n                                    <div class=\"clearfix\"></div>\n                                    <div class=\"row\" *ngIf=\"item?.engraving_option?.dangles?.symbols\">\n                                      <div class=\"col-4 text-left\">\n                                        <label>Symbol/s:</label>\n                                      </div>\n                                      <div class=\"col-8 text-left\">\n                                        <p>{{ item?.engraving_option?.dangles.symbols }}</p>\n                                      </div>\n                                    </div>\n\n                                    <div class=\"row\" *ngIf=\"item?.engraving_option?.dangles?.type == 'initial'\">\n                                      <div class=\"col-4 text-left\">\n                                        <label>Initial:</label>\n                                      </div>\n                                      <div class=\"col-8 text-left\">\n                                        <p>{{ item?.engraving_option?.dangles.initial }}</p>\n                                      </div>\n                                    </div>\n                                  </div>\n\n\n                                </div>\n\n                                <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.initial_text\">\n                                <div class=\"col-md-12\">\n                                  <h6>Initial:</h6>\n                                  <div class=\"row\">\n                                    <div class=\"col-4 text-left\">\n                                      <label>Initial:</label>\n                                    </div>\n                                    <div class=\"col-8 text-left\">\n                                      <p>{{ item.engraving_option?.initial_text }}</p>\n                                    </div>\n                                  </div>\n                                </div>\n\n                                </div>\n\n                                <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.discs\">\n                                  <div class=\"col-md-12\">\n                                    <h6>Discs:</h6>\n\n                                    <div class=\"row\">\n                                      <div class=\"col-4 text-left\">\n                                        <label>Discs ({{ item?.engraving_option.discs.no_of_discs}}):</label>\n                                      </div>\n                                      <div class=\"col-8 text-left\">\n                                        <p><b>Text:</b> {{ item.engraving_option?.discs.engraving }}</p>\n                                      </div>\n                                    </div>\n                                  </div>\n\n                                </div>\n\n                                <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.text\">\n                                  <div class=\"col-12\">\n                                    <h6>Engraving:</h6>\n\n                                    <div class=\"row\">\n                                      <div class=\"col-4 text-left\">\n                                        <label>Text:</label>\n                                      </div>\n                                      <div class=\"col-8 text-left\">\n                                        <p>{{ item.engraving_option?.text }}</p>\n                                      </div>\n                                      <div class=\"col-4 text-left\">\n                                        <label>Sides:</label>\n                                      </div>\n                                      <div class=\"col-8 text-left\">\n                                        <p>{{ item.engraving_option?.sides }}</p>\n                                      </div>\n                                      <div class=\"col-4 text-left\">\n                                        <label>Font:</label>\n                                      </div>\n                                      <div class=\"col-8 text-left\">\n                                        <p>{{ item.engraving_option?.font }}</p>\n                                      </div>\n                                    </div>\n                                  </div>\n\n                                </div>\n\n                                <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.stones\">\n                                  <div class=\"col-12\">\n                                    <h6>Stones:</h6>\n                                    <div class=\"row\">\n                                      <div class=\"col-4 text-left\">\n                                        <label>Stones:</label>\n                                      </div>\n                                      <div class=\"col-8 text-left\">\n                                        <p *ngFor=\"let stone of item.engraving_option?.stones\">{{ stone.stone_name }},</p>\n                                      </div>\n                                    </div>\n                                  </div>\n\n                                </div>\n\n                                <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.print_image_data\">\n                                  <div class=\"col-4 text-left\">\n                                    <label>Print Image :</label>\n                                  </div>\n                                  <div class=\"col-8 text-left\" >\n                                    <span *ngIf=\"item?.engraving_option?.print_image_data?.print_image_type\">\n                                      ({{ item?.engraving_option?.print_image_data?.print_image_type?.name }})\n                                    </span>\n                                    <img [src]=\"item.print_image_url | imageUrl\" class=\"img-w50\" *ngIf=\"item?.print_image_url\" />\n                                  </div>\n                                </div>\n\n                              </ng-template>\n\n                            -->\n                        </div>\n\n\n                    </div>\n                </td>\n\n                <td>{{ item.quantity }}</td>\n\n                <td *ngIf=\"isCart\">\n                    {{ item.product_variant ? item.product_variant.product_variant_price : item.product.actual_price  | currency }}\n                </td>\n                <td *ngIf=\"!isCart\">{{ item.price | currency}}</td>\n\n              </tr>\n            </table>\n\n\n            <!-- Customization Options Starts -->\n            <ng-template [ngIf]=\"item?.engraving_option\">\n              <table class=\"table order-sum-tbl-1 custom-tbl-wrap\">\n                <colgroup>\n                  <col width=\"100%\" />\n                </colgroup>\n                <tr>\n\n                  <td>\n                      <div class=\"pro-info div-float\">\n                          <div class=\"pro-info-txt text-left\">\n\n                            <!-- <div class=\"clearfix\"></div> -->\n                            <hr />\n                            <h4>Customization Options:</h4>\n                            <hr />\n\n                            <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.interlocking_option\">\n\n                              <div class=\"col-md-12\">\n                                <h6>Interlocking:</h6>\n\n                                <div class=\"row\">\n                                  <div class=\"col-5 text-left\">\n                                    <label>Interlocking Metal Color:</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p>{{ item?.engraving_option?.interlocking_option.variant }}</p>\n                                  </div>\n                                </div>\n                              </div>\n\n                            </div>\n\n                            <div class=\"row bxtxt-mid dangles\" *ngIf=\"item?.engraving_option?.dangles\">\n\n                              <div class=\"col-md-12\">\n                                <h6>Dangles:</h6>\n                                <div class=\"row\">\n                                  <div class=\"col-5 text-left\">\n                                    <label>Quantity:</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p>{{ item?.engraving_option?.dangles.quantity }}</p>\n                                  </div>\n                                </div>\n\n                                <div class=\"row\">\n                                  <div class=\"col-5 text-left\">\n                                    <label>Type:</label>\n                                  </div>\n\n                                  <div class=\"col-7 text-left\">\n                                    <p>{{ item?.engraving_option?.dangles.type }}</p>\n                                  </div>\n                                </div>\n\n                                <div class=\"clearfix\"></div>\n                                <div class=\"row\" *ngIf=\"item?.engraving_option?.dangles?.symbols\">\n                                  <div class=\"col-5 text-left\">\n                                    <label>Symbol/s:</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p>{{ item?.engraving_option?.dangles.symbols }}</p>\n                                  </div>\n                                </div>\n\n                                <div class=\"row\" *ngIf=\"item?.engraving_option?.dangles?.type == 'initial'\">\n                                  <div class=\"col-5 text-left\">\n                                    <label>Initial:</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p>{{ item?.engraving_option?.dangles.initial }}</p>\n                                  </div>\n                                </div>\n                              </div>\n\n\n                            </div>\n\n                            <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.initial_text\">\n                            <div class=\"col-md-12\">\n                              <h6>Initial:</h6>\n                              <div class=\"row\">\n                                <div class=\"col-5 text-left\">\n                                  <label>Initial:</label>\n                                </div>\n                                <div class=\"col-7 text-left\">\n                                  <p>{{ item.engraving_option?.initial_text }}</p>\n                                </div>\n                              </div>\n                            </div>\n\n                            </div>\n\n                            <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.discs\">\n                              <div class=\"col-md-12\">\n                                <h6>Discs:</h6>\n\n                                <div class=\"row\">\n                                  <div class=\"col-5 text-left\">\n                                    <label>Discs ({{ item?.engraving_option.discs.no_of_discs}}):</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p><b>Text:</b> {{ item.engraving_option?.discs.engraving }}</p>\n                                  </div>\n                                </div>\n                              </div>\n\n                            </div>\n\n                            <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.text\">\n                              <div class=\"col-12\">\n                                <h6>Engraving:</h6>\n\n                                <div class=\"row\">\n                                  <div class=\"col-5 text-left\">\n                                    <label>Text:</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p>{{ item.engraving_option?.text }}</p>\n                                  </div>\n                                  <div class=\"col-5 text-left\">\n                                    <label>Sides:</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p>{{ item.engraving_option?.sides }}</p>\n                                  </div>\n                                  <div class=\"col-5 text-left\">\n                                    <label>Font:</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p>{{ item.engraving_option?.font }}</p>\n                                  </div>\n                                </div>\n                              </div>\n\n                            </div>\n\n                            <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.stones\">\n                              <div class=\"col-12\">\n                                <h6>Stones:</h6>\n                                <div class=\"row\">\n                                  <div class=\"col-5 text-left\">\n                                    <label>Stones:</label>\n                                  </div>\n                                  <div class=\"col-7 text-left\">\n                                    <p *ngFor=\"let stone of item.engraving_option?.stones; let i=index\">{{ stone.stone_name }}\n                                      <span *ngIf=\"i != item.engraving_option?.stones.length - 1\">,</span>\n                                    </p>\n                                  </div>\n                                </div>\n                              </div>\n\n                            </div>\n\n                            <div class=\"row bxtxt-mid\" *ngIf=\"item?.engraving_option?.print_image_data\">\n                              <div class=\"col-5 text-left\">\n                                <label>Print Image :</label>\n                              </div>\n                              <div class=\"col-7 text-left\" >\n                                <span *ngIf=\"item?.engraving_option?.print_image_data?.print_image_type\">\n                                  ({{ item?.engraving_option?.print_image_data?.print_image_type?.name }})\n                                </span>\n                                <img [src]=\"item.print_image_url | imageUrl\" class=\"img-w50\" *ngIf=\"item?.print_image_url\" />\n                              </div>\n                            </div>\n\n                          </div>\n\n\n                      </div>\n                  </td>\n\n                </tr>\n              </table>\n            </ng-template>\n            <!-- Customization Options Ends -->\n\n        </td>\n\n        </tr>\n\n    </table>\n    <table class=\"table sub-tol orderSumarySubtotal\">\n        <thead>\n            <tr>\n                <th style=\"width: 75%;\"></th>\n                <th style=\"width: 25%;\"></th>\n            </tr>\n        </thead>\n        <tbody>\n            <tr>\n                <td>\n                    <div class=\"tr2-td1\">\n                        <label>Subtotal:</label>\n                        <!-- <span>Shipping:</span> -->\n                        <!-- <span>Tax:</span> -->\n                        <span *ngIf=\"order?.discount && order?.discount != 0\">Discount:</span>\n                    </div>\n                </td>\n\n                <td>\n                    <div class=\"tr2-td1 text-right\">\n                        <label *ngIf=\"!isCart\">{{ order?.total  | currency }}</label>\n                        <label *ngIf=\"isCart\">{{ order?.subtotal  | currency }}</label>\n                        <!-- <span>$0.00</span> -->\n                        <!-- <span>$0.00</span> -->\n                        <span *ngIf=\"order?.discount && order?.discount != 0\">{{ order?.discount | currency  }}</span>\n                    </div>\n                </td>\n            </tr>\n\n            <tr>\n                <td>\n                    <div class=\"tr2-td1 text-right\">\n                        <label class=\"fnt-bld\">Order Total</label>\n                    </div>\n                </td>\n                <td>\n                    <div class=\"tr2-td1 text-right\">\n                        <label class=\"fnt-bld\" *ngIf=\"!isCart\">{{ order?.total - order?.discount | currency }}</label>\n                        <label class=\"fnt-bld\" *ngIf=\"isCart\">{{ order?.total | currency}}</label>\n                    </div>\n                </td>\n            </tr>\n        </tbody>\n    </table>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/perk/perk.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/perk/perk.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\" *ngIf=\"perks.length > 0\">\n    <div class=\"col-12 col-sm-6 col-md-3\" *ngFor=\"let perk of perks\">\n        <div class=\"vc1\">\n            <table>\n                <tr>\n                    <td>\n                        <img src=\"{{ perk.icon_url | imageUrl }}\" alt=\"{{ perk.title }}\" />\n                    </td>\n                </tr>\n            </table> \n            <div class=\"vc1-content\">\n                <h5>{{ perk.title }}</h5>\n                <p>{{ perk.description }}</p>\n            </div>\n        </div>\n    </div>\t\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-filters/product-filters.component.html":
/*!************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-filters/product-filters.component.html ***!
  \************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"about-pro\">\n        <ng-template ngFor let-filter [ngForOf]=\"filters\" >\n\n          <!-- DYNAMIC FILTERS TEMPLATE -->\n          <ng-template [ngIf]=\"filter.product_option != 'By Occasion' && filter.product_option != 'Prices' && filter.product_option != 'Shop By Insta' \">\n            <div class=\"side-section pro-check-set div-float\" *ngIf=\"filter.option_values.length > 0\">\n                <h3>{{ filter.product_option }}\n                  <span class=\"scdul-icon\" appExpandLists [values]=\"filter.option_values\" [icon]=\"'scdul-icon2'\"></span>\n                </h3>\n                <ul appExpandLists [values]=\"filter.option_values\">\n                  <li *ngFor=\"let option of filter.option_values; let i=index\" >\n                    <div class=\"price-con\">\n                      <label class=\"price-check\">\n                        <input type=\"checkbox\" class=\"qa-check\" value=\"{{ filter.product_option }}|{{ option.id }}\" (click)=\"optionChecked($event)\" [checked]=\"option.checked\" />\n                        <span class=\"checkmark3\"></span> {{ option.option_value_name }}\n                      </label>\n                    </div>\n                  </li>\n                </ul>\n                <!-- <a href=\"javascript:void(0)\" class=\"show-more\"  *ngIf=\"filter.option_values.length > 5\">+ SEE MORE</a> -->\n            </div>\n          </ng-template>\n          <!-- END DYNAMIC FILTERS TEMPLATE -->\n\n\n            <!-- PRICES TEMPLATE -->\n            <ng-template [ngIf]=\"filter.product_option == 'Prices'\">\n                <div class=\"side-section pro-check-set div-float\">\n                    <h3>Price\n                        <span class=\"scdul-icon\" appExpandLists [values]=\"filter.option_values\" [icon]=\"'scdul-icon2'\"></span>\n                    </h3>\n\n                    <ul appExpandLists [values]=\"filter.option_values\">\n                        <li *ngIf=\"selectedPrice\">\n                            <a href=\"javascript:void(0)\" (click)=\"clearPrice()\">Clear</a>\n                        </li>\n\n                        <li *ngFor=\"let opt of filter.option_values; let i=index\">\n\n                            <div class=\"price-con\">\n                                <label class=\"price-check\">\n                                    <input type=\"checkbox\" class=\"qa-check\"\n                                           value=\"price|{{i == 0 ? 0 : (i == filter?.option_values?.length - 1 ? 'above' : opt.price   )}}\"\n                                           (click)=\"i == filter.option_values.length - 1 ?  maxPriceSelected($event, opt, filter.option_values[i-1].price) : priceSelected($event, opt)\"\n                                           min=\"{{ i == 0 ? 0 : filter.option_values[i-1].price }}\"\n                                           max=\"{{ opt.price }}\"\n                                           [checked]=\"opt.checked\" />\n                                    <span class=\"checkmark3\"></span> {{opt.name}}\n                                </label>\n                            </div>\n                        </li>\n                    </ul>\n\n                </div>\n            </ng-template>\n            <!-- END PRICES TEMPLATE -->\n\n\n          <!-- BY OCCASIONS TEMPLATE-->\n          <ng-template [ngIf]=\"filter.product_option == 'By Occasion'\">\n              <div class=\"side-section pro-check-set div-float\" *ngIf=\"filter.option_values.length > 0\">\n                  <h3>{{ filter.name }}\n                      <span class=\"scdul-icon\" appExpandLists [values]=\"filter.option_values\" [icon]=\"'scdul-icon2'\"></span>\n                  </h3>\n                  <ul appExpandLists [values]=\"filter.option_values\">\n                    <li *ngFor=\"let occasion of filter.option_values; let i=index\"  [ngClass]=\"{'d-none': i > 5 }\">\n                      <div class=\"price-con\">\n                        <label class=\"price-check\">\n                          <input type=\"checkbox\" class=\"qa-check\" value=\"occasions|{{ occasion.id }}\" (click)=\"optionChecked($event)\" [checked]=\"occasion.checked\" />\n                          <span class=\"checkmark3\"></span> {{ occasion.name }}\n                        </label>\n                      </div>\n                    </li>\n                  </ul>\n                  <!-- <a href=\"javascript:void(0)\" class=\"show-more\" *ngIf=\"occasions?.length > 5\">+ SEE MORE </a> -->\n              </div>\n          </ng-template>\n          <!-- END OCCASIONS TEMPLATE -->\n\n\n          <!-- INSTAGRAM TEMPLATE -->\n          <ng-template [ngIf]=\"filter.product_option == 'Shop By Insta' && filter.count > 0\">\n              <div class=\"side-section pro-check-set div-float\">\n                  <h3 (click)=\"byInsta()\" [ngClass]=\"{'selectedFilter': selectedInsta}\">{{ filter.name }}</h3>\n                </div>\n          </ng-template>\n          <!-- END INSTAGRAM TEMPLATE -->\n\n\n        </ng-template>\n\n        <a href=\"javascript:void(0)\" class=\"btn btn-primary btn-custom\" *ngIf=\"!isEmpty(filterOption)\" (click)=\"resetAll()\">Reset All</a>\n\n      </div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-options/product-options.component.html":
/*!************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-options/product-options.component.html ***!
  \************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row bxtxt-mid resizeFonts\" *ngFor=\"let option of options\">\n    <div class=\"col-5 text-left\">\n        <label>{{ option.product_option }}:</label>\n    </div>\n    <div class=\"col-7 text-left\">\n        <p>{{ option.option_value_name }}</p>\n    </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-price/product-price.component.html":
/*!********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-price/product-price.component.html ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<span class=\"sale_price\" *ngIf=\"product.sale_price && product.sale_price != product.price\" style=\"color:red\">\n    {{ product.sale_price | currency }}\n    </span>\n<span [ngClass]=\"{ 'cut': product.sale_price && product.sale_price != product.price }\">{{ product.price | currency }}</span>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/recent-blogs/recent-blogs.component.html":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/recent-blogs/recent-blogs.component.html ***!
  \******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"recent div-float\">\n    <h3>Recent Posts</h3>\n    <hr>\n    <span class=\"tbr\"></span>\n    <div class=\"re-post div-float\" *ngFor=\"let post of recentPost\">\n        <ng-template [ngIf]=\"post.id != currentBlog\">\n            <a [routerLink]=\"['/blogs', post.id]\"> \n                <div class=\"post-img\">\n                    <img src=\"{{ post.featured_image | imageUrl }}\" alt=\"ka-post\" />\n                </div>\n                <div class=\"post-text\">\n                    <h4>{{ post.title }}</h4>\n                    <p>{{ post.created_at | formatDate | date: 'MMM dd, y' }}</p>\n                </div>\n            </a>\n    \n        </ng-template>\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/related-products/related-products.component.html":
/*!**************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/related-products/related-products.component.html ***!
  \**************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- Related Section Starts -->\n<section class=\"relted-item\">\n    <div class=\"container-fluid\">\n        <div class=\"wrapper\">\n    \n            <!-- Related Header Starts -->\n            <div class=\"row\">\n            <div class=\"col-md-12\">\n                <div class=\"div-float\">\n                <h3>Related Items</h3>\n                </div>\n            </div>\n            </div>\n            <!-- Related Header Ends -->\n    \n            <!-- Related Product Row Starts -->\n            <div class=\"row imghovr\">\n    \n                <!-- Related Product Col Starts -->\n                <div class=\"col-12 col-sm-6 col-md-3\" *ngFor=\"let product of products\">\n                    <div class=\"sec-secs1\">\n\n                         <!-- New Image Box Start -->\n                        <div class=\"img-nbox\">\n                        <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\">\n                          <tr>\n                            <td>\n                                <a [routerLink]=\"['/products', category, product.slug]\" (click)=\"onClickProduct(product)\" style=\"text-decoration: none;\">\n                                    <img [src]=\"product.image_full_url | imageUrl\" [alt]=\"product.name\" class=\"img-fluid\">\n                                </a>\n                            </td>\n                          </tr>\n                        </table>\n                      </div>\n                      <!-- New Image Box Ends -->\n\n                    <div class=\"sec-secs-txt\">\n                        <a [routerLink]=\"['/products', category, product.slug]\" style=\"text-decoration: none;\">\n                        <h4>{{ product.name }}</h4></a>\n                        <!-- <p>Sample Text Here Sample Text Here Sample Text Here</p> -->\n                        <div class=\"wish-fav div-float\">\n                            <app-product-price [product]=\"product\"></app-product-price>\n                        </div>\n                    </div>\n                    </div>\n                </div>\n                <!-- Related Product Col Ends -->\n            </div>\n            <!-- Related Product Row Ends -->\n    \n        </div>\n    </div>\n</section>\n<!-- Related Section Ends -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/review-address/review-address.component.html":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/review-address/review-address.component.html ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"vew-ord-sec\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"custm-tit\">\n          <h4>{{ title }}</h4>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row crt-ord\">\n      <div class=\"col-lg-4 col-md-6 col-sm-5\">\n        <div class=\"div-float\">\n          <label>Name</label>\n        </div>\n      </div>\n      <div class=\"col-lg-8 col-md-6 col-sm-7\">\n        <div class=\"div-float\">\n          <p>\n            {{\n              data?.billing_first_name +\n                \" \" +\n                data?.billing_last_name\n            }}\n          </p>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row crt-ord\">\n      <div class=\"col-lg-4 col-md-6 col-sm-5\">\n        <div class=\"div-float\">\n          <label>Street address:</label>\n        </div>\n      </div>\n      <div class=\"col-lg-8 col-md-6 col-sm-7\">\n        <div class=\"div-float\">\n          <p>{{ data?.billing_address1 }}</p>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row crt-ord\">\n      <div class=\"col-lg-4 col-md-6 col-sm-5\">\n        <div class=\"div-float\">\n          <label>Street address 2:</label>\n        </div>\n      </div>\n      <div class=\"col-lg-8 col-md-6 col-sm-7\">\n        <div class=\"div-float\">\n          <p>{{ data?.billing_address2 }}</p>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row crt-ord\">\n      <div class=\"col-lg-4 col-md-6 col-sm-5\">\n        <div class=\"div-float\">\n          <label>City:</label>\n        </div>\n      </div>\n      <div class=\"col-lg-8 col-md-6 col-sm-7\">\n        <div class=\"div-float\">\n          <p>{{ data?.billing_city }}</p>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row crt-ord\">\n      <div class=\"col-lg-4 col-md-6 col-sm-5\">\n        <div class=\"div-float\">\n          <label>State:</label>\n        </div>\n      </div>\n      <div class=\"col-lg-8 col-md-6 col-sm-7\">\n        <div class=\"div-float\">\n          <p>{{ data?.billing_state }}</p>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row crt-ord\">\n      <div class=\"col-lg-4 col-md-6 col-sm-5\">\n        <div class=\"div-float\">\n          <label>Zip:</label>\n        </div>\n      </div>\n      <div class=\"col-lg-8 col-md-6 col-sm-7\">\n        <div class=\"div-float\">\n          <p>{{ data?.billing_postal_code }}</p>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row crt-ord\">\n      <div class=\"col-lg-4 col-md-6 col-sm-5\">\n        <div class=\"div-float\">\n          <label>Phone:</label>\n        </div>\n      </div>\n      <div class=\"col-lg-8 col-md-6 col-sm-7\">\n        <div class=\"div-float\">\n          <p>{{ data?.billing_phone_no }}</p>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"row crt-ord\">\n      <div class=\"col-lg-4 col-md-6 col-sm-5\">\n        <div class=\"div-float\">\n          <label>Email address::</label>\n        </div>\n      </div>\n      <div class=\"col-lg-8 col-md-6 col-sm-7\">\n        <div class=\"div-float\">\n          <p>{{ data?.billing_email }}</p>\n        </div>\n      </div>\n    </div>\n  </div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/reviews/reviews.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/reviews/reviews.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ng-template ngFor [ngForOf]=\"reviews\" let-review let-i=\"index\">\n  <div class=\"ordr-reviewd div-float\" *ngIf=\"limit > i\">\n    <div class=\"row\">\n      <div class=\"col-md-3\">\n        <div class=\"review-txt div-float\">\n          <span>{{review.review_by }}</span>\n          <p>{{review.created_at | formatDate | date:'fullDate'}}</p>\n        </div>\n      </div>\n      <div class=\"col-md-9\">\n        <div class=\"review-odrd-det div-float\">\n          <div class=\"strs\">\n            <star-rating [starType]=\"'svg'\" [rating]=\"review.rating\" size=\"large\" [readOnly]=\"true\" staticColor=\"ok\">\n            </star-rating>\n          </div>\n          <div class=\"ordr-des\">\n            <h4>{{review.title}}</h4>\n            <p>\n              {{review.review}}\n            </p>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n\n\n<div class=\"ordr-reviewd div-float\" *ngIf=\"reviews.length > limit\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"div-float text-center\" [ngStyle]=\"{'margin-top': '50px'}\">\n        <h5>Showing {{limit}} of {{reviews.length - 1}}</h5>\n        <button type=\"button\" class=\"btn1 vm-btn\" (click)=\"viewMore()\">VIEW MORE</button>\n      </div>\n    </div>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/sidebar-menu/sidebar-menu.component.html":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/sidebar-menu/sidebar-menu.component.html ***!
  \******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"ka-side-menu\">\n  <div class=\"prfl-lft-sec\">\n    <ul>\n      <li *ngFor=\"let menu of menus\" [ngClass]=\"{ active: slug == menu.slug }\">\n        <a (click)=\"linkClick(menu.slug)\" href=\"javascript:void(0)\">\n                {{ menu.slug == 'faqs' ? 'FAQs' : menu.title }}</a>\n      </li>\n    </ul>\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/subscribe/subscribe.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/subscribe/subscribe.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"subscribe div-float\">\n    <h3>EMAIL SUBSCRIBE</h3>\n    <hr>\n    <span class=\"tbr\"></span>\n    <p>Sample Text Here Sample Text Here</p>\n    <div class=\"subscribe-form div-float\">\n        <form [formGroup]=\"form\" (ngSubmit)=\"onSubmit(form.value)\" novalidate>\n            <div class=\"sub-field\">\n                <input type=\"text\" name=\"\" placeholder=\"Your Name\" class=\"qa-name\" formControlName=\"name\" />\n            </div>  \n\n            <div class=\"sub-field\"> \n                <input type=\"text\" name=\"\" placeholder=\"Your Email\" class=\"qa-email\" formControlName=\"email\" />\n                <div class=\"error-block\" *ngIf=\"form.get('email').hasError('required') && (form.get('email').dirty || form.get('email').touched)\">This field is required.</div>\n                <div class=\"error-block\" *ngIf=\"form.get('email').hasError('email') && (form.get('email').dirty || form.get('email').touched)\">Email is invalid.</div>\n            </div>\n\n            <button type=\"submit\" class=\"btn1 btn6 qa-btn\">SUBSCRIBE</button>\n        </form>\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/team/team.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/team/team.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\n    <div class=\"col-md-12\">\n        <h3 class=\"team-head\">THE TEAM</h3>\n    </div>\n</div>\n<div class=\"row mb-5\" *ngFor=\"let member of team\">\n    <div class=\"col-md-12\">\n        <div class=\"team-img\">\n            <img src=\"{{ member.image | imageUrl }}\" alt=\"{{ member.name }}\" />\n        </div>\n        <div class=\"team-info\">\n            <h4>{{ member.name }}</h4>\n            <h5>{{ member.designation }}</h5>\n\n            <p [innerHTML]=\"member.about\"></p>\n            \n        </div>\n    </div>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/footer/footer.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/footer/footer.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<footer *ngIf=\"showFooter\">\n\n\t<div class=\"container-fluid\">\n\t\t<div class=\"wrapper\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-6 col-lg-6\">\n\t\t\t\t\t<div class=\"ftr-lft\">\n\t\t\t\t\t\t<div class=\"ftr-lft-upr\">\n\t\t\t\t\t\t\t<form [formGroup]=\"newsLetterForm\" (ngSubmit)=\"onSubmitNewsletter(newsLetterForm.value)\" novalidate>\n\t\t\t\t\t\t\t\t<div class=\"ftr-chk\">\n\t\t\t\t\t\t\t\t\t<!-- <label class=\"ftr-chkbx\">\n\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" formControlName=\"agree\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"checkmark2\"></span>\n\t\t\t\t\t\t\t\t\t</label> -->\n\t\t\t\t\t\t\t\t\t<!-- <p>\n\t\t\t\t\t\t\t\t\t\tI am 16 years or older and I agree to the Privacy Policy By clicking Subscribe, agree that my information can be used for marketing purposes.\n\t\t\t\t\t\t\t\t\t</p> -->\n\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\tWant to know about our latest offers and what's new and exciting on Kate Adam?\n\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t<div class=\"error-block\" *ngIf=\"!newsLetterForm.get('agree').valid && (newsLetterForm.get('agree').dirty || newsLetterForm.get('agree').touched)\">This field is required.</div>\n\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"footerSubscribeField\">\n\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"email\" placeholder=\"Email Address\" formControlName=\"email\" />\n\t\t\t\t\t\t\t\t\t <div class=\"error-block\" *ngIf=\"newsLetterForm.get('email').hasError('required') && (newsLetterForm.get('email').dirty || newsLetterForm.get('email').touched)\">This field is required.</div>\n\t\t\t\t\t\t\t\t\t<div class=\"error-block\" *ngIf=\"newsLetterForm.get('email').hasError('email') && (newsLetterForm.get('email').dirty || newsLetterForm.get('email').touched)\">Email is invalid.</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button type=\"submit\">OH YEAH</button>\n\n\n\t\t\t\t\t\t\t</form>\n\n\n\n\t\t\t\t\t\t\t<div class=\"ftr-social\">\n\t\t\t\t\t\t\t\t<a href=\"#\">\n\t\t\t\t\t\t\t\t\t<i class=\"fab fa-facebook-f\"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<a href=\"#\">\n\t\t\t\t\t\t\t\t\t<i class=\"fab fa-twitter\"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<a href=\"#\">\n\t\t\t\t\t\t\t\t\t<i class=\"fab fa-google-plus-g\"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"col-lg-1 d-md-none\"></div>\n\n\t\t\t\t<div class=\"col-md-6 col-lg-5\">\n\t\t\t\t\t<div class=\"ftr-links\">\n\t\t\t\t\t\t<div class=\"ftr-50\">\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li *ngFor=\"let menu of footer_menu_1\">\n\t\t\t\t\t\t\t\t\t<a routerLink=\"{{ menu.menu_type == 'post' ? '/post/' : '/' }}{{ menu.url }}\">{{ menu.title == 'Faqs' ? 'FAQs' : menu.title }}</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"ftr-50\">\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t<li><a href=\"mailto:{{ email }}\" class=\"email-clr\">{{ email }}</a></li>\n\t\t\t\t\t\t\t\t<li>{{ phone }}</li>\n\t\t\t\t\t\t\t\t<li *ngFor=\"let menu of footer_menu_2\">\n\t\t\t\t\t\t\t\t\t<a href=\"{{ menu.menu_type == 'post' && menu.url != '' ? '/post/' : (menu.url != '' ? '/' : 'javascript:void(0)') }}{{ menu.url }}\">{{ menu.title }}</a>\n\t\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t\t<ng-template #staticUrl let-menu=\"menu\">\n\t\t\t\t\t\t\t\t\t<a href=\"#\">{{ menu.title }}</a>\n\t\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"ftr-bg\">\n\t\t<div class=\"wrapper\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t<div class=\"copy-txt\">\n\t\t\t\t\t\t<p>Copyright © 2021 KA. All Right Reserved.</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t<div class=\"ftr-logo\">\n\t\t\t\t\t\t<a routerLink=\"/\">\n\t\t\t\t\t\t\t<img src=\"{{ logo | imageUrl }}\" alt=\"Logo\" class=\"img-fluid\">\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t<div class=\"lwr-ftrlnk\">\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li><a routerLink=\"/terms-and-conditions\">Terms and conditions</a></li>\n\t\t\t\t\t\t\t<li>|</li>\n\t\t\t\t\t\t\t<li><a routerLink=\"/privacy-and-policy\">Privacy Policy</a></li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n</footer>\n\n<app-forgot-password></app-forgot-password>\n\n <!-- The Modal -->\n <div class=\"modal\" id=\"reset\">\n    <div class=\"modal-dialog forgot-model\">\n      <div class=\"modal-content forgot-content\">\n\n        <!-- Modal Header -->\n        <div class=\"modal-header pop-head\">\n          <button type=\"button\" class=\"close cut\" data-dismiss=\"modal\">x</button>\n        </div>\n\n        <!-- Modal body -->\n        <div class=\"modal-body pop-body\">\n          <h1>RESET PASSWORD</h1>\n          <p>Sample Text Here Sample Text Here Sample Text Here Sample Text Here.</p>\n\n          <div class=\"contact-form-fields\">\n             <div class=\"contact-form-label\">\n                 <label>New password</label>\n             </div>\n             <div class=\"contact-field\">\n                 <input type=\"text\" name=\"\"  />\n             </div>\n             <div class=\"error\">Please fill the required field.</div>\n         </div>\n\n         <div class=\"contact-form-fields\">\n             <div class=\"contact-form-label\">\n                 <label>Confirm password</label>\n             </div>\n             <div class=\"contact-field\">\n                 <input type=\"text\" name=\"\"  />\n             </div>\n             <div class=\"error\">Please fill the required field.</div>\n         </div>\n\n         <div class=\"contact-btn\">\n             <button class=\"btn1 btn5\" type=\"submit\">SUBMIT</button>\n         </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/header/header.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/header/header.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- Header starts here -->\n<div id=\"headerCover\" style=\"display: none;\"></div>\n<header class=\"div-float header\" [ngClass]=\"{\n  'regNotLog': !isLoggedIn\n}\" id=\"sticky-header\">\n\t<div class=\"container-fluid\">\n\t\t<div class=\"wrapper\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-12\">\n\t\t\t\t\t<div class=\"div-float header-inner\">\n\n\t\t\t\t\t\t<span class=\"bars\" onclick=\"openNav()\">&nbsp;</span>\n            <!-- <a class=\"logo\" routerLink=\"/\"><img src=\"{{ logo | imageUrl }}\" alt=\"company logo\" /></a> -->\n            <a class=\"logo\" routerLink=\"\"><img src=\"/assets/images/kate-and-adam.png\" alt=\"kate & adam\" /></a>\n\t\t\t\t\t\t<span class=\"mobile-btn-rgt\"><i class=\"fas fa-caret-down\"></i></span>\n\t\t\t\t\t\t<div class=\"header-rgt\">\n\t\t\t\t\t\t\t<!-- <a class=\"reload-btn\" href=\"javascript:void(0);\" title=\"\">&nbsp;</a>\n\t\t\t\t\t\t\t<a class=\"profile-btn\" href=\"javascript:void(0);\" title=\"\">&nbsp;</a>\n\t\t\t\t\t\t\t<a class=\"heart-btn\" href=\"javascript:void(0);\" title=\"\">&nbsp;</a> -->\n\t\t\t\t\t\t\t<a class=\"bag-btn\" href=\"javascript:void(0);\" title=\"Cart\" (click)=\"goToCart()\">&nbsp;\n                <span class=\"crt-circle\" *ngIf=\"cartCount\">{{ cartCount }}</span>\n              </a>\n\t\t\t\t\t\t\t<a class=\"search-btn\" href=\"javascript:void(0);\" title=\"Search\" (click)=\"showSearch = !showSearch\">&nbsp;</a>\n              <a *ngIf=\"!isLoggedIn\" class=\"register-btn profile-btn\" title=\"Sign In/Register\"><span>&nbsp;</span>Sign In/Register</a>\n\n              <!-- Drop Starts -->\n              <div class=\"loggedInbtn\" *ngIf=\"isLoggedIn\">\n                <a *ngIf=\"isLoggedIn\" class=\"profile-btn2\" title=\"My Account\" href=\"javascript:void(0);\">&nbsp;</a>\n\n                <!-- Account Login Drop Down Starts -->\n                <div class=\"login-form2\" style=\"display: none;\"  *ngIf=\"isLoggedIn\">\n                  <div class=\"login-form2inner\">\n                    <ul>\n                      <li>\n                        <a (click)=\"goToProfile()\" href=\"javascript:void(0)\">My Account</a>\n                      </li>\n                      <li>\n                        <a href=\"javascript:void(0)\" (click)=\"logout()\">Sign Out</a>\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n                <!-- Account Login Drop Down Ends -->\n\n              </div>\n              <!-- Drop Ends -->\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<app-login-form></app-login-form>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n  \t\t<app-side-nav></app-side-nav>\n</header>\n\n\n  <!-- Search starts here -->\n<section class=\"srch-sec div-float\" [ngStyle]=\"{ 'display' : showSearch ? 'block' : 'none' }\">\n  <div class=\"container\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n          <div class=\"srch-cros div-float\" (click)=\"showSearch = false;\">\n            <a href=\"#\">X</a>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <div class=\"srch-fld div-float\">\n                <input type=\"text\" name=\"search\" [(ngModel)]=\"searchQuery\" id=\"searchBox\" (keyup)=\"search($event)\" />\n                <button type=\"button\" class=\"\" (click)=\"searchDetailPage(); showSearch = false\"><img src=\"/assets/images/srch-img.png\" alt=\"img\" /></button>\n              </div>\n            </div>\n          </div>\n          <div class=\"srch-prdt\" id=\"main\">\n           <div class=\"row\" *ngIf=\"searchRecords && searchRecords.length > 0\">\n              <div class=\"col-lg-2 col-md-4 col-sm-6 col-xs-12\" *ngFor=\"let product of searchRecords\">\n                <div class=\"srch-img-txt div-float\">\n                      <div class=\"srch-img div-float\">\n                          <a href=\"{{ product.link }}\"><img [src]=\"product.image\" [alt]=\"product.name\" /></a>\n                      </div>\n                      <div class=\"srch-txt div-float\">\n                          <h5>{{ product.name }}</h5>\n                          <!-- <app-product-price [product]=\"product.dataPoints[0]\"></app-product-price> -->\n                      </div>\n                </div>\n            </div>\n           </div>\n           <app-not-found *ngIf=\"searchRecords && !searchRecords.length\" [text]=\"'SORRY, NO RESULTS FOUND'\"></app-not-found>\n            <div class=\"mt-5\" *ngIf=\"suggestProducts && suggestProducts.length > 0\">\n              <h4>OH, YOU MIGHT ALSO LIKE</h4>\n              <div class=\"row\" >\n                <div class=\"col-lg-2 col-md-4 col-sm-6 col-xs-12\" *ngFor=\"let item of suggestProducts\">\n                  <div class=\"srch-img-txt div-float\">\n                    <div class=\"srch-img div-float\">\n                      <a [routerLink]=\"['/products', item.slug, item.having_product.product.slug ]\" (click)=\"showSearch = !showSearch\"><img [src]=\"item.having_product.product.image_full_url | imageUrl\" [alt]=\"item.having_product.product.name\" /></a>\n                    </div>\n                    <div class=\"srch-txt div-float\">\n                      <h5>{{ item.having_product.product.name }}</h5>\n                      <p>{{ item.having_product.product.short_description | excerpt}}</p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n    </div>\n  </div>\n</section>\n\n<!-- Search ends here -->\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/side-nav/side-nav.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/side-nav/side-nav.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"mySidenav\" class=\"sidenav\">\n  <a href=\"javascript:void(0)\" class=\"closebtn\" onclick=\"closeNav()\">&times;</a>\n  <!-- <div class=\"sidebar-logo\">\n    <a [routerLink]=\"['/']\"\n      ><img src=\"/assets/images/logo.png\" alt=\"company logo\"\n    /></a>\n  </div> -->\n  <div class=\"navSec\">\n\n    <div class=\"sidenav-inner\">\n      <a [routerLink]=\"['/']\" onclick=\"closeNav()\">Home</a>\n    </div>\n    <!-- <div class=\"sidenav-inner\">\n      <a routerLink=\"/about-us\" onclick=\"closeNav()\">About Us</a>\n    </div> -->\n    <div class=\"sidenav-inner\">\n\n      <a href=\"javascript:void(0)\" class=\"prd-clck\">Shop by Category</a>\n\n      <!-- Sub Nav Starts -->\n      <div class=\"subnav-main\">\n        <div class=\"container\">\n          <!-- <div class=\"row\">\n            <a href=\"javascript: void(0)\" class=\"bck\"> Back </a>\n          </div> -->\n          <div class=\"row\">\n            <div class=\"col-md-12\" *ngFor=\"let category of categories\">\n              <div class=\"submnuan\">\n                <a routerLink=\"/products/categories/{{ category.slug }}\" onclick=\"closeNav()\">{{ category.name }}</a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- Sub Nav Ends -->\n\n    </div>\n\n    <div class=\"sidenav-inner\">\n      <a routerLink=\"/occasions\" onclick=\"closeNav()\">Shop by Occasion</a>\n    </div>\n\n    <div class=\"sidenav-inner\">\n      <a href=\"javascript:void(0)\" class=\"fpd-nav\">As seen on</a>\n      <span class=\"hed-sol-icon\">\n        <a href=\"#\">\n          <i class=\"fab fa-facebook-f\"></i>\n        </a>\n      </span>\n      <span class=\"hed-sol-icon\">\n        <a href=\"#\">\n          <i class=\"fab fa-twitter\"></i>\n        </a>\n      </span>\n      <span class=\"hed-sol-icon\">\n        <a href=\"#\">\n          <i class=\"fab fa-instagram\"></i>\n        </a>\n      </span>\n    </div>\n\n\n    <div class=\"sidenav-inner\" *ngFor=\"let item of pagesMenu\">\n      <a [routerLink]=\"['/', item.slug ]\" onclick=\"closeNav()\">{{ item.title }}</a>\n    </div>\n\n    <div class=\"secnd-nav\">\n      <div class=\"sidenav-inner\">\n        <a routerLink=\"/login\" onclick=\"closeNav()\" class=\"text-capitalize\">sign in / register</a>\n        <span class=\"hed-sol-icon\">\n          <a href=\"#\">\n            <i class=\"fas fa-user\"></i>\n          </a>\n        </span>\n      </div>\n\n      <div class=\"sidenav-inner\">\n        <a routerLink=\"/account/wishlist\" onclick=\"closeNav()\" class=\"text-capitalize\">My wishlist</a>\n        <span class=\"hed-sol-icon\">\n          <a href=\"#\">\n            <i class=\"fas fa-heart\"></i>\n          </a>\n        </span>\n      </div>\n    </div>\n\n\n  </div>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _layout_layout_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./layout/layout.component */ "./src/app/layout/layout.component.ts");
/* harmony import */ var _layout_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./layout/routes */ "./src/app/layout/routes.ts");
/* harmony import */ var _pages_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./pages/page-not-found/page-not-found.component */ "./src/app/pages/page-not-found/page-not-found.component.ts");






const routes = [
    {
        path: '',
        redirectTo: 'pages',
        pathMatch: 'full',
    },
    {
        path: '',
        component: _layout_layout_component__WEBPACK_IMPORTED_MODULE_3__["LayoutComponent"],
        children: _layout_routes__WEBPACK_IMPORTED_MODULE_4__["Full_ROUTES"]
    },
    { path: 'page-not-found', component: _pages_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_5__["PageNotFoundComponent"] },
    { path: '**', redirectTo: 'page-not-found' },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes, {
                onSameUrlNavigation: 'reload',
                scrollPositionRestoration: 'top'
            })],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppComponent = class AppComponent {
    constructor() {
        this.title = 'DC';
    }
    onWindowScroll() {
        let headerElement = document.getElementById('sticky-header');
        let headerCover = document.getElementById('headerCover');
        var mainBody = document.body;
        if (headerElement) {
            if (!headerElement.classList.contains("sticky-header")) {
                headerCover.style.height = headerElement.offsetHeight + 'px';
            }
        }
        if (document.body.scrollTop > 50 ||
            document.documentElement.scrollTop > 50) {
            document.getElementById('sticky-header').classList.add('sticky-header');
            headerCover.style.display = 'block';
            mainBody.classList.add("removeBstyle");
        }
        else {
            headerCover.style.display = 'none';
            document.getElementById('sticky-header').classList.remove('sticky-header');
            mainBody.classList.remove("removeBstyle");
        }
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:scroll', [])
], AppComponent.prototype, "onWindowScroll", null);
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: gettoken, AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gettoken", function() { return gettoken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _shared_shared_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./shared/shared.module */ "./src/app/shared/shared.module.ts");
/* harmony import */ var _layout_layout_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./layout/layout.component */ "./src/app/layout/layout.component.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _shared_api_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./shared/api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _ngx_progressbar_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @ngx-progressbar/core */ "./node_modules/@ngx-progressbar/core/fesm2015/ngx-progressbar-core.js");
/* harmony import */ var _ngx_progressbar_http__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @ngx-progressbar/http */ "./node_modules/@ngx-progressbar/http/fesm2015/ngx-progressbar-http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _shared_auth_auth_service___WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./shared/auth/auth.service  */ "./src/app/shared/auth/auth.service .ts");
/* harmony import */ var _shared_auth_auth_guard_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./shared/auth/auth-guard.service */ "./src/app/shared/auth/auth-guard.service.ts");
/* harmony import */ var _auth0_angular_jwt__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @auth0/angular-jwt */ "./node_modules/@auth0/angular-jwt/index.js");
/* harmony import */ var _search_details_search_details_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./search-details/search-details.component */ "./src/app/search-details/search-details.component.ts");
/* harmony import */ var _ngx_meta_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @ngx-meta/core */ "./node_modules/@ngx-meta/core/fesm2015/ngx-meta-core.js");
/* harmony import */ var ngx_disqus__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ngx-disqus */ "./node_modules/ngx-disqus/fesm2015/ngx-disqus.js");
/* harmony import */ var _pages_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./pages/page-not-found/page-not-found.component */ "./src/app/pages/page-not-found/page-not-found.component.ts");





















function gettoken() {
    return localStorage.getItem('access_token');
}
;
const jwtConf = {
    config: {
        tokenGetter: gettoken,
    }
};
let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"],
            _layout_layout_component__WEBPACK_IMPORTED_MODULE_6__["LayoutComponent"],
            _search_details_search_details_component__WEBPACK_IMPORTED_MODULE_17__["SearchDetailsComponent"],
            _pages_page_not_found_page_not_found_component__WEBPACK_IMPORTED_MODULE_20__["PageNotFoundComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"].withServerTransition({ appId: 'serverApp' }),
            _app_routing_module__WEBPACK_IMPORTED_MODULE_3__["AppRoutingModule"],
            _shared_shared_module__WEBPACK_IMPORTED_MODULE_5__["SharedModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_7__["HttpClientModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_7__["HttpClientModule"],
            _ngx_progressbar_core__WEBPACK_IMPORTED_MODULE_9__["NgProgressModule"].withConfig({
                spinner: false
            }),
            _ngx_progressbar_http__WEBPACK_IMPORTED_MODULE_10__["NgProgressHttpModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_11__["ReactiveFormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_11__["FormsModule"],
            ngx_toastr__WEBPACK_IMPORTED_MODULE_12__["ToastrModule"].forRoot({
                positionClass: 'toast-bottom-right'
            }),
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_13__["BrowserAnimationsModule"],
            _auth0_angular_jwt__WEBPACK_IMPORTED_MODULE_16__["JwtModule"].forRoot(jwtConf),
            _ngx_meta_core__WEBPACK_IMPORTED_MODULE_18__["MetaModule"].forRoot(),
            ngx_disqus__WEBPACK_IMPORTED_MODULE_19__["DisqusModule"].forRoot('https-ka-dotlogicstest-com'),
        ],
        providers: [_shared_api_service__WEBPACK_IMPORTED_MODULE_8__["ApiService"], _shared_auth_auth_service___WEBPACK_IMPORTED_MODULE_14__["AuthService"], _shared_auth_auth_guard_service__WEBPACK_IMPORTED_MODULE_15__["AuthGuardService"]],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/layout/layout.component.css":
/*!*********************************************!*\
  !*** ./src/app/layout/layout.component.css ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2xheW91dC9sYXlvdXQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/layout/layout.component.ts":
/*!********************************************!*\
  !*** ./src/app/layout/layout.component.ts ***!
  \********************************************/
/*! exports provided: LayoutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LayoutComponent", function() { return LayoutComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _shared_api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _shared_libs_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/libs/localstorage */ "./src/app/shared/libs/localstorage.ts");
/* harmony import */ var _shared_services_cart_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/services/cart.service */ "./src/app/shared/services/cart.service.ts");
/* harmony import */ var _shared_services_meta_tags_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../shared/services/meta-tags.service */ "./src/app/shared/services/meta-tags.service.ts");
/* harmony import */ var _ngx_meta_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngx-meta/core */ "./node_modules/@ngx-meta/core/fesm2015/ngx-meta-core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _shared_services_helper_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../shared/services/helper.service */ "./src/app/shared/services/helper.service.ts");









let LayoutComponent = class LayoutComponent {
    constructor(apiService, localStorage, cartService, meta, metaTagsService, platformId, helperService) {
        this.apiService = apiService;
        this.localStorage = localStorage;
        this.cartService = cartService;
        this.meta = meta;
        this.metaTagsService = metaTagsService;
        this.platformId = platformId;
        this.helperService = helperService;
    }
    ngOnInit() {
        if (Object(_angular_common__WEBPACK_IMPORTED_MODULE_7__["isPlatformBrowser"])(this.platformId)) {
            this.siteSettings();
            let sessionId = this.localStorage.get('sessionId');
            if (!sessionId) {
                sessionId = Math.random().toString(36).substr(2, 25);
                this.localStorage.set('sessionId', sessionId);
            }
        }
        this.metaTagsService.currentMeta.subscribe(tags => {
            if (!this.metaTagsService.isEmpty(tags)) {
                this.meta.setTitle(tags.title);
                this.meta.setTag('keywords', tags.meta_keywords);
                this.meta.setTag('description', tags.meta_description);
                if (tags.og) {
                    this.meta.setTag('og:title', tags.og.title);
                    this.meta.setTag('og:keywords', tags.og.meta_keywords);
                    this.meta.setTag('og:description', tags.og.meta_description);
                    this.meta.setTag('og:image', tags.og.image);
                    this.meta.setTag('og:url', tags.og.url);
                }
            }
        });
    }
    onActivate(event) {
        if (Object(_angular_common__WEBPACK_IMPORTED_MODULE_7__["isPlatformBrowser"])(this.platformId)) {
            window.scroll(0, 0);
        }
    }
    siteSettings() {
        this.apiService.siteSettings().subscribe(res => {
            this.localStorage.setObject('site_settings', res.result);
        });
        let cart = this.localStorage.getObject('cart');
        if (this.isEmpty(cart) || cart == undefined) {
            this.apiService.mycart().subscribe(res => {
                if (res.status) {
                    this.localStorage.setObject('cart', res.result);
                    let cartCount = 0;
                    res.result.products.forEach(product => {
                        cartCount = Number(cartCount) + Number(product.quantity);
                    });
                    this.cartService.setCartCount(cartCount);
                }
            }, err => {
                // console.clear();
            });
        }
        else {
            let cartCount = 0;
            cart.products.forEach(product => {
                cartCount = Number(cartCount) + Number(product.quantity);
            });
            this.cartService.setCartCount(cartCount);
        }
        //console.clear();
    }
    isEmpty(object) {
        return Object.keys(object).length === 0;
    }
    ngAfterViewInit() {
    }
};
LayoutComponent.ctorParameters = () => [
    { type: _shared_api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] },
    { type: _shared_libs_localstorage__WEBPACK_IMPORTED_MODULE_3__["LocalStorage"] },
    { type: _shared_services_cart_service__WEBPACK_IMPORTED_MODULE_4__["CartService"] },
    { type: _ngx_meta_core__WEBPACK_IMPORTED_MODULE_6__["MetaService"] },
    { type: _shared_services_meta_tags_service__WEBPACK_IMPORTED_MODULE_5__["MetaTagsService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"],] }] },
    { type: _shared_services_helper_service__WEBPACK_IMPORTED_MODULE_8__["HelperService"] }
];
LayoutComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-layout',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./layout.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/layout/layout.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./layout.component.css */ "./src/app/layout/layout.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](5, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"]))
], LayoutComponent);



/***/ }),

/***/ "./src/app/layout/routes.ts":
/*!**********************************!*\
  !*** ./src/app/layout/routes.ts ***!
  \**********************************/
/*! exports provided: Full_ROUTES */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Full_ROUTES", function() { return Full_ROUTES; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _search_details_search_details_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../search-details/search-details.component */ "./src/app/search-details/search-details.component.ts");
/* harmony import */ var _shared_auth_auth_guard_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/auth/auth-guard.service */ "./src/app/shared/auth/auth-guard.service.ts");



const Full_ROUTES = [
    {
        path: '',
        loadChildren: './pages/pages.module#PagesModule',
    },
    {
        path: 'post',
        loadChildren: './posts/posts.module#PostsModule'
    },
    {
        path: 'blogs',
        loadChildren: './blogs/blogs.module#BlogsModule'
    },
    {
        path: 'products',
        loadChildren: './products/products.module#ProductsModule',
    },
    {
        path: 'account',
        loadChildren: './my-account/my-account.module#MyAccountModule',
        canActivate: [_shared_auth_auth_guard_service__WEBPACK_IMPORTED_MODULE_2__["AuthGuardService"]]
    },
    {
        path: 'cart',
        loadChildren: './cart/cart.module#CartModule'
    },
    {
        path: 'search-details',
        component: _search_details_search_details_component__WEBPACK_IMPORTED_MODULE_1__["SearchDetailsComponent"],
        data: {
            title: 'Search Details'
        }
    },
];


/***/ }),

/***/ "./src/app/my-account/account.service.ts":
/*!***********************************************!*\
  !*** ./src/app/my-account/account.service.ts ***!
  \***********************************************/
/*! exports provided: AccountService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AccountService", function() { return AccountService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _shared_auth_auth_service___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/auth/auth.service  */ "./src/app/shared/auth/auth.service .ts");





let AccountService = class AccountService {
    constructor(platformId, auth) {
        this.platformId = platformId;
        this.auth = auth;
        this.subTitle = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]('');
        this.subTitleBreadCrum = this.subTitle.asObservable();
        this.titlePath = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]('');
        this.currentTitlePath = this.titlePath.asObservable();
        this.isLoggedIn = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](false);
        this.currentLoggedInStatus = this.isLoggedIn.asObservable();
        this.breadCrumTitle = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]('');
        this.breadCrumPageTitle = this.breadCrumTitle.asObservable();
        if (Object(_angular_common__WEBPACK_IMPORTED_MODULE_3__["isPlatformBrowser"])(this.platformId)) {
            if (this.auth.isAuthenticated()) {
                this.isLoggedIn.next(true);
            }
        }
    }
    setLoggedInStatus(value) {
        this.isLoggedIn.next(value);
    }
    setTitle(title) {
        this.title = title;
    }
    setTitlePath(path) {
        this.titlePath.next(path);
    }
    getTitle() {
        return this.title;
    }
    setBreadCrumSubtitle(title) {
        this.subTitle.next(title);
    }
    setBreadCrumPageTitle(path) {
        this.breadCrumTitle.next(path);
    }
};
AccountService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"],] }] },
    { type: _shared_auth_auth_service___WEBPACK_IMPORTED_MODULE_4__["AuthService"] }
];
AccountService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"]))
], AccountService);



/***/ }),

/***/ "./src/app/pages/page-not-found/page-not-found.component.css":
/*!*******************************************************************!*\
  !*** ./src/app/pages/page-not-found/page-not-found.component.css ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3BhZ2VzL3BhZ2Utbm90LWZvdW5kL3BhZ2Utbm90LWZvdW5kLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/pages/page-not-found/page-not-found.component.ts":
/*!******************************************************************!*\
  !*** ./src/app/pages/page-not-found/page-not-found.component.ts ***!
  \******************************************************************/
/*! exports provided: PageNotFoundComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PageNotFoundComponent", function() { return PageNotFoundComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let PageNotFoundComponent = class PageNotFoundComponent {
    constructor(route) {
        this.route = route;
    }
    ngOnInit() {
    }
};
PageNotFoundComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] }
];
PageNotFoundComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-page-not-found',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./page-not-found.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/pages/page-not-found/page-not-found.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./page-not-found.component.css */ "./src/app/pages/page-not-found/page-not-found.component.css")).default]
    })
], PageNotFoundComponent);



/***/ }),

/***/ "./src/app/search-details/search-details.component.css":
/*!*************************************************************!*\
  !*** ./src/app/search-details/search-details.component.css ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NlYXJjaC1kZXRhaWxzL3NlYXJjaC1kZXRhaWxzLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/search-details/search-details.component.ts":
/*!************************************************************!*\
  !*** ./src/app/search-details/search-details.component.ts ***!
  \************************************************************/
/*! exports provided: SearchDetailsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SearchDetailsComponent", function() { return SearchDetailsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _shared_api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _shared_services_helper_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../shared/services/helper.service */ "./src/app/shared/services/helper.service.ts");






const qs = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
let SearchDetailsComponent = class SearchDetailsComponent {
    constructor(route, router, apiService, title, helperService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.title = title;
        this.helperService = helperService;
        this.searchRecords = [];
        this.title.setTitle(this.route.snapshot.data['title']);
        this.helperService.showFooter.next(false);
        this.route.queryParamMap.subscribe(params => {
            let param = params['params'];
            this.query = param.query;
            this.apiService.search(this.query).subscribe(res => {
                if (res.suggests.hasOwnProperty('_')) {
                    this.searchRecords = res.suggests._;
                }
                else {
                    this.searchRecords = [];
                }
                this.helperService.showFooter.next(true);
            });
        });
    }
    ngOnInit() {
    }
    sort(ev) {
        if (ev.target.value == 'low_to_high') {
            this.searchRecords.sort((a, b) => (a.actual_price < b.actual_price) ? -1 : 1);
        }
        else {
            this.searchRecords.sort((a, b) => (a.actual_price > b.actual_price) ? 1 : -1);
        }
    }
};
SearchDetailsComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _shared_api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_4__["Title"] },
    { type: _shared_services_helper_service__WEBPACK_IMPORTED_MODULE_5__["HelperService"] }
];
SearchDetailsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-search-details',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./search-details.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/search-details/search-details.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./search-details.component.css */ "./src/app/search-details/search-details.component.css")).default]
    })
], SearchDetailsComponent);



/***/ }),

/***/ "./src/app/shared/api.service.ts":
/*!***************************************!*\
  !*** ./src/app/shared/api.service.ts ***!
  \***************************************/
/*! exports provided: ApiService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiService", function() { return ApiService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _libs_localstorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./libs/localstorage */ "./src/app/shared/libs/localstorage.ts");
/* harmony import */ var _ngx_meta_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ngx-meta/core */ "./node_modules/@ngx-meta/core/fesm2015/ngx-meta-core.js");







const qs = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
let ApiService = class ApiService {
    constructor(http, route, localStorage, meta) {
        this.http = http;
        this.route = route;
        this.localStorage = localStorage;
        this.meta = meta;
        this.url = src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl;
    }
    isEmpty(object) {
        return Object.keys(object).length === 0;
    }
    resetLink(token) {
        const url = `${this.url}validateResetLink/${token}`;
        return this.http.get(url);
    }
    loadScript(url, type = 'text/javascript') {
        const body = document.body;
        const script = document.createElement('script');
        script.innerHTML = '';
        script.type = type;
        script.src = url;
        script.async = false;
        script.defer = true;
        body.appendChild(script);
    }
    touchAllFields(form) {
        //touch all fields to show the error
        Object.keys(form.controls).forEach(field => {
            const control = form.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }
    homepage() {
        const url = this.url + 'page/homepage';
        return this.http.get(url);
    }
    about(slug) {
        const url = this.url + 'page/' + slug;
        return this.http.get(url);
    }
    page(slug) {
        const url = this.url + 'page/' + slug;
        return this.http.get(url);
    }
    addContactQuery(formData) {
        const url = this.url + 'contact-queries';
        return this.http.post(url, formData);
    }
    submitReview(formData) {
        const url = this.url + 'product-reviews?token=' + this.localStorage.get('token');
        return this.http.post(url, formData);
    }
    getPost(slug) {
        const url = this.url + 'post/' + slug;
        return this.http.get(url);
    }
    getMenu(name) {
        const url = this.url + 'menus/' + name;
        return this.http.get(url);
    }
    getPagesMenu() {
        const url = this.url + 'pages-menu';
        return this.http.get(url);
    }
    //postMenu/sidebar-posts
    getSidebarMenu(slug) {
        const url = this.url + 'postMenu/' + slug;
        return this.http.get(url);
    }
    getBlogs(category) {
        let url = this.url + 'posts';
        if (category) {
            url = url + '?category=' + category;
        }
        return this.http.get(url);
    }
    singlePost(id) {
        const url = this.url + 'posts/' + id;
        return this.http.get(url);
    }
    recentPosts() {
        const url = this.url + 'posts/recent';
        return this.http.get(url);
    }
    subscribe(formData) {
        const url = this.url + 'subscribe';
        return this.http.post(url, formData);
    }
    siteSettings() {
        const url = this.url + 'settings';
        return this.http.get(url);
    }
    /* ------------------------------------------------ */
    /*         USER ACCOUNT APIs
    /* ------------------------------------------------ */
    register(formData) {
        const url = this.url + 'users';
        return this.http.post(url, formData);
    }
    updateOrder(formData) {
        const url = this.url + 'orders/update';
        return this.http.post(url, formData);
    }
    login(formData) {
        const url = this.url + 'auth/login';
        return this.http.post(url, formData);
    }
    //logout
    logout() {
        const url = this.url + 'logout?token=' + this.localStorage.get('token');
        return this.http.get(url);
    }
    //forgot
    forgot(formData) {
        const url = this.url + 'forgot_password';
        return this.http.post(url, formData);
    }
    //reset Password
    reset(formData) {
        const url = this.url + 'password/reset';
        return this.http.post(url, formData);
    }
    user() {
        let token = this.localStorage.get('token');
        const url = `${this.url}user?token=${token}`;
        return this.http.get(url);
    }
    updateUser(formData, id) {
        let token = this.localStorage.get('token');
        const url = `${this.url}users/${id}?token=${token}`;
        return this.http.put(url, formData);
    }
    updatePassword(formData) {
        let token = this.localStorage.get('token');
        const url = `${this.url}user/change_password?token=${token}`;
        return this.http.post(url, formData);
    }
    /* ------------------------------------------------ */
    /*               PRODUCTS
    /* ------------------------------------------------ */
    products(query) {
        let url = this.url + 'products';
        query = qs.stringify(query);
        if (query)
            url = url + '?' + query;
        return this.http.get(url);
    }
    productsByCategory(slug, query) {
        let url = this.url + 'products/getByCategory/' + slug;
        query = qs.stringify(query);
        if (query)
            url = url + '?' + query;
        return this.http.get(url);
    }
    getProduct(category, slug) {
        let url = this.url + 'product/' + category + '/' + slug;
        return this.http.get(url);
    }
    productCategories() {
        const url = this.url + 'categories?isPagination=0&active=1';
        return this.http.get(url);
    }
    productOptions(category) {
        const url = `${this.url}products/getOptions/${category}`;
        return this.http.get(url);
    }
    filterProducts(formData) {
        let url = this.url + 'products/filter';
        return this.http.post(url, formData);
    }
    occasions() {
        const url = `${this.url}ocassions?isPagination=0&active=1`;
        return this.http.get(url);
    }
    productVariant(slug) {
        const url = `${this.url}product/variant/${slug}`;
        return this.http.get(url);
    }
    productSuggestions() {
        const url = `${this.url}products/suggestions`;
        return this.http.get(url);
    }
    /* ------------------------------------------------ */
    /*         CART API
    /* ------------------------------------------------ */
    addToCart(formData) {
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Authorization': 'Bearer ' + this.localStorage.get('token') });
        const url = `${this.url}cart/add`;
        return this.http.post(url, formData, { headers: headers });
    }
    mycart() {
        let sessionId = this.localStorage.get('sessionId');
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Authorization': 'Bearer ' + this.localStorage.get('token') });
        const url = `${this.url}cart/mycart?session_id=${sessionId}`;
        return this.http.get(url, { headers: headers });
    }
    updateCart(formData, cartID) {
        const url = `${this.url}cart/update/${cartID}`;
        return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
    }
    getAuthorizationHeader() {
        return new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Authorization': 'Bearer ' + this.localStorage.get('token') });
    }
    deleteCartItem(id) {
        const url = `${this.url}cart/delete/${id}`;
        return this.http.delete(url);
    }
    changeQuantity(formData) {
        const url = `${this.url}cart/changeQuantity`;
        return this.http.post(url, formData);
    }
    checkout(formData) {
        //payment/pay
        const url = `${this.url}payment/checkout`;
        return this.http.post(url, formData, { headers: this.getAuthorizationHeader() });
    }
    myCards() {
        const url = `${this.url}payment/my-saved-cards?token=${this.localStorage.get('token')}`;
        return this.http.get(url);
    }
    syncCart() {
        const header = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Authorization': 'Bearer ' + this.localStorage.get('token') });
        const url = `${this.url}cart/syncCart/${this.localStorage.get('sessionId')}`;
        return this.http.get(url, { headers: header });
    }
    /* ------------------------------------------------ */
    /*         IMAGE CUSTOMIZATOIN API
    /* ------------------------------------------------ */
    engraving(formData) {
        //  const query = qs.stringify(formData)
        const url = `${this.url}image/engraving`;
        return this.http.post(url, formData);
    }
    /* ------------------------------------------------ */
    /*         MISCELLENIOUS
    /* ------------------------------------------------ */
    countries() {
        const url = `${this.url}countries`;
        return this.http.get(url);
    }
    states(countryId) {
        const url = `${this.url}states/${countryId}`;
        return this.http.get(url);
    }
    mywishlist() {
        const url = `${this.url}wishlist?token=${this.localStorage.get('token')}`;
        return this.http.get(url);
    }
    productWishList(product_id) {
        const url = `${this.url}wishlist/${product_id}?token=${this.localStorage.get('token')}`;
        return this.http.get(url);
    }
    wishlist(formData) {
        //wishlist/addOrRemove
        const url = `${this.url}wishlist/addOrRemove?token=${this.localStorage.get('token')}`;
        return this.http.post(url, formData);
    }
    /* ------------------------------------------------ */
    /*              ADDRESS BOOK APIs
    /* ------------------------------------------------ */
    defaultAddresses() {
        let url = `${this.url}defaultAddresses?token=` + this.localStorage.get('token');
        return this.http.get(url);
    }
    addressBooks() {
        let url = `${this.url}addressBooks?token=` + this.localStorage.get('token');
        return this.http.get(url);
    }
    applyCoupon(formData) {
        //discount/calculate
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Authorization': 'Bearer ' + this.localStorage.get('token') });
        let url = `${this.url}discount/calculate`;
        return this.http.post(url, formData, { headers });
    }
    removeCoupon(formData) {
        //discount/remove
        let url = `${this.url}discount/remove`;
        return this.http.post(url, formData);
    }
    /* ------------------------------------------------ */
    /*               BASIC CRUD
    /* ------------------------------------------------ */
    save(model, formData, token) {
        let url = `${this.url}${model}`;
        if (token) {
            url += '?token=' + token;
        }
        return this.http.post(url, formData);
    }
    all(model, isPagination = 1, token) {
        let url = `${this.url}${model}?isPagination=${isPagination}`;
        if (token) {
            url += '&token=' + token;
        }
        return this.http.get(url);
    }
    single(model, id, token) {
        let url = `${this.url}${model}/${id}`;
        if (token) {
            url += '?token=' + token;
        }
        return this.http.get(url);
    }
    update(model, formData, id, token) {
        let url = `${this.url}${model}/${id}`;
        if (token) {
            url += '?token=' + token;
        }
        return this.http.put(url, formData);
    }
    delete(model, id, token) {
        let url = `${this.url}${model}/${id}`;
        if (token) {
            url += '?token=' + token;
        }
        return this.http.delete(url);
    }
    /* ------------------------------------------------ */
    /*               ORDERS
    /* ------------------------------------------------ */
    myOrders(query) {
        query = qs.stringify(query);
        let url = `${this.url}orders/myOrders?${query}&token=` + this.localStorage.get('token');
        return this.http.get(url);
    }
    orderById(order_id) {
        let url = `${this.url}orders/getById/${order_id}?token=${this.localStorage.get('token')}`;
        return this.http.get(url);
    }
    getMyOrderNumbers() {
        let url = `${this.url}orders/getMyOrderNumbers?token=${this.localStorage.get('token')}`;
        return this.http.get(url);
    }
    /* ------------------------------------------------ */
    /*               SITE360 SEARCH
    /* ------------------------------------------------ */
    //  search(query: string, limit = null) : Observable<any> {
    //     const headers = new HttpHeaders({'ignoreProgressBar': ''});
    //     let url = `https://api.sitesearch360.com/sites?query=${query}&site=${environment.site360_siteId}&highlightQueryTerms=true&filterOptions=true&includeContent=true`
    //     if(limit) {
    //       url += '&limit=' + limit
    //     }
    //     return this.http.get(url, {headers: headers})
    //  }
    search(query, limit = null) {
        let url = this.url + 'products/searchProducts/' + query;
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'ignoreProgressBar': '' });
        return this.http.get(url);
    }
    validateUserEmail(email) {
        const headers = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'ignoreProgressBar': '' });
        let url = `${this.url}user/checkEmail/${email}`;
        return this.http.get(url, { headers: headers });
    }
    exists(data) {
        return data !== undefined && data !== null && data !== '';
    }
    addMetaTags(data) {
        this.meta.setTag('twitter:card', 'summary');
        if (this.exists(data.meta_title)) {
            this.meta.setTitle(data.meta_title);
            this.meta.setTag('og:title', data.meta_title);
            this.meta.setTag('twitter:title', data.meta_title);
        }
        else if (this.exists(data.name)) {
            this.meta.setTitle(data.name);
            this.meta.setTag('og:title', data.name);
            this.meta.setTag('twitter:title', data.name);
        }
        if (this.exists(data.meta_keywords)) {
            this.meta.setTag('keywords', data.meta_keywords);
            this.meta.setTag('og:keywords', data.meta_keywords);
        }
        if (this.exists(data.meta_description)) {
            this.meta.setTag('description', data.meta_description);
            this.meta.setTag('og:description', data.meta_description);
            this.meta.setTag('twitter:description', data.meta_description);
        }
        // if(this.exists(data.meta_description)) {
        //   this.meta.setTag('description', data.meta_description)
        // }
        if (this.exists(data.image_full_url)) {
            this.meta.setTag('og:image', src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].storageUrl + data.image_full_url);
            this.meta.setTag('twitter:image', src_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].storageUrl + data.image_full_url);
        }
        this.meta.setTag('og:url', window.location.href);
    }
    /* ------------------------------------------------ */
    /*              MY ACCOUNT
    /* ------------------------------------------------ */
    myPaymentCards() {
        let url = `${this.url}payment/my-saved-cards?token=${this.localStorage.get('token')}`;
        return this.http.get(url);
    }
    deletePaymentCard(formData) {
        let url = `${this.url}payment/delete-card?token=${this.localStorage.get('token')}`;
        return this.http.post(url, formData);
    }
    addPaymentCard(formData) {
        let url = `${this.url}payment/save_card?token=${this.localStorage.get('token')}`;
        return this.http.post(url, formData);
    }
    removeMetaTags() {
        this.meta.removeTag('name=title');
        this.meta.removeTag('name=keywords');
        this.meta.removeTag('name=description');
        this.meta.removeTag('property="og:title"');
        this.meta.removeTag('property="og:keywords"');
        this.meta.removeTag('property="og:description"');
        this.meta.removeTag('property="og:image"');
        this.meta.removeTag('property="og:url"');
    }
};
ApiService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: _libs_localstorage__WEBPACK_IMPORTED_MODULE_5__["LocalStorage"] },
    { type: _ngx_meta_core__WEBPACK_IMPORTED_MODULE_6__["MetaService"] }
];
ApiService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], ApiService);



/***/ }),

/***/ "./src/app/shared/auth/auth-guard.service.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/auth/auth-guard.service.ts ***!
  \***************************************************/
/*! exports provided: AuthGuardService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuardService", function() { return AuthGuardService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _auth_service___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./auth.service  */ "./src/app/shared/auth/auth.service .ts");




let AuthGuardService = class AuthGuardService {
    constructor(auth, router) {
        this.auth = auth;
        this.router = router;
    }
    canActivate() {
        if (!this.auth.isAuthenticated()) {
            this.router.navigate(['login']);
            return false;
        }
        return true;
    }
};
AuthGuardService.ctorParameters = () => [
    { type: _auth_service___WEBPACK_IMPORTED_MODULE_3__["AuthService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AuthGuardService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AuthGuardService);



/***/ }),

/***/ "./src/app/shared/auth/auth.service .ts":
/*!**********************************************!*\
  !*** ./src/app/shared/auth/auth.service .ts ***!
  \**********************************************/
/*! exports provided: AuthService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthService", function() { return AuthService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _auth0_angular_jwt__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @auth0/angular-jwt */ "./node_modules/@auth0/angular-jwt/index.js");
/* harmony import */ var _libs_localstorage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../libs/localstorage */ "./src/app/shared/libs/localstorage.ts");




let AuthService = class AuthService {
    constructor(jwtHelper, localStorage) {
        this.jwtHelper = jwtHelper;
        this.localStorage = localStorage;
    }
    // ...
    isAuthenticated() {
        const token = this.localStorage.get('token');
        // Check whether the token is expired and return
        // true or false
        if (token) {
            return !this.jwtHelper.isTokenExpired(token);
        }
        else {
            return false;
        }
    }
};
AuthService.ctorParameters = () => [
    { type: _auth0_angular_jwt__WEBPACK_IMPORTED_MODULE_2__["JwtHelperService"] },
    { type: _libs_localstorage__WEBPACK_IMPORTED_MODULE_3__["LocalStorage"] }
];
AuthService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], AuthService);



/***/ }),

/***/ "./src/app/shared/components/category/Categories.ts":
/*!**********************************************************!*\
  !*** ./src/app/shared/components/category/Categories.ts ***!
  \**********************************************************/
/*! exports provided: Categories */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Categories", function() { return Categories; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Categories {
}


/***/ }),

/***/ "./src/app/shared/components/category/category.component.css":
/*!*******************************************************************!*\
  !*** ./src/app/shared/components/category/category.component.css ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2NhdGVnb3J5L2NhdGVnb3J5LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/shared/components/category/category.component.ts":
/*!******************************************************************!*\
  !*** ./src/app/shared/components/category/category.component.ts ***!
  \******************************************************************/
/*! exports provided: CategoryComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CategoryComponent", function() { return CategoryComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _Categories__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Categories */ "./src/app/shared/components/category/Categories.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");




let CategoryComponent = class CategoryComponent {
    constructor(route, router) {
        this.route = route;
        this.router = router;
        this.categories = [_Categories__WEBPACK_IMPORTED_MODULE_2__["Categories"]];
        this.isOccassions = false;
        this.viewMoreLink = '/categories';
        this.link = '/products/categories';
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
        //Add '${implements OnChanges}' to the class.
        if (this.isOccassions) {
            this.link = '/products/occasions';
        }
    }
    productListing(category) {
        if (!this.isOccassions) {
            this.router.navigate(['/products/categories', category.slug]);
        }
    }
};
CategoryComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CategoryComponent.prototype, "categories", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CategoryComponent.prototype, "isOccassions", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], CategoryComponent.prototype, "viewMoreLink", void 0);
CategoryComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-category',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./category.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/category/category.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./category.component.css */ "./src/app/shared/components/category/category.component.css")).default]
    })
], CategoryComponent);



/***/ }),

/***/ "./src/app/shared/components/contact-form/contact-form.component.css":
/*!***************************************************************************!*\
  !*** ./src/app/shared/components/contact-form/contact-form.component.css ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2NvbnRhY3QtZm9ybS9jb250YWN0LWZvcm0uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/shared/components/contact-form/contact-form.component.ts":
/*!**************************************************************************!*\
  !*** ./src/app/shared/components/contact-form/contact-form.component.ts ***!
  \**************************************************************************/
/*! exports provided: ContactFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactFormComponent", function() { return ContactFormComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var ngx_toastr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-toastr */ "./node_modules/ngx-toastr/fesm2015/ngx-toastr.js");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/shared/services/helper.service.ts");
/* harmony import */ var _constants_Constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../constants/Constants */ "./src/app/shared/constants/Constants.ts");







let ContactFormComponent = class ContactFormComponent {
    constructor(fb, apiServices, toastr, helperService) {
        this.fb = fb;
        this.apiServices = apiServices;
        this.toastr = toastr;
        this.helperService = helperService;
        this.disableSubmit = false;
        this.createForm();
    }
    ngOnInit() {
    }
    createForm() {
        this.form = this.fb.group({
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].email]],
            subject: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].maxLength(150)]],
            message: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
    }
    submit(form) {
        if (this.form.valid) {
            this.disableSubmit = true;
            this.apiServices.addContactQuery(form).subscribe(res => {
                this.disableSubmit = false;
                this.helperService.successAlert('Thank you for contacting us, we\'ll be in touch.', '', _constants_Constants__WEBPACK_IMPORTED_MODULE_6__["Constants"].logo, '');
                this.form.reset();
            }, err => {
                this.disableSubmit = false;
                this.helperService.errorAlert(err.error.message);
            });
        }
        else {
            this.apiServices.touchAllFields(this.form);
        }
    }
};
ContactFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: ngx_toastr__WEBPACK_IMPORTED_MODULE_4__["ToastrService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_5__["HelperService"] }
];
ContactFormComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-contact-form',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./contact-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/contact-form/contact-form.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./contact-form.component.css */ "./src/app/shared/components/contact-form/contact-form.component.css")).default]
    })
], ContactFormComponent);



/***/ }),

/***/ "./src/app/shared/components/faq/faq.component.css":
/*!*********************************************************!*\
  !*** ./src/app/shared/components/faq/faq.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2ZhcS9mYXEuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/shared/components/faq/faq.component.ts":
/*!********************************************************!*\
  !*** ./src/app/shared/components/faq/faq.component.ts ***!
  \********************************************************/
/*! exports provided: FaqComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FaqComponent", function() { return FaqComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let FaqComponent = class FaqComponent {
    constructor() {
        this.faqs = [];
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], FaqComponent.prototype, "faqs", void 0);
FaqComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-faq',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./faq.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/faq/faq.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./faq.component.css */ "./src/app/shared/components/faq/faq.component.css")).default]
    })
], FaqComponent);



/***/ }),

/***/ "./src/app/shared/components/forgot-password/forgot-password.component.css":
/*!*********************************************************************************!*\
  !*** ./src/app/shared/components/forgot-password/forgot-password.component.css ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2ZvcmdvdC1wYXNzd29yZC9mb3Jnb3QtcGFzc3dvcmQuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/shared/components/forgot-password/forgot-password.component.ts":
/*!********************************************************************************!*\
  !*** ./src/app/shared/components/forgot-password/forgot-password.component.ts ***!
  \********************************************************************************/
/*! exports provided: ForgotPasswordComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ForgotPasswordComponent", function() { return ForgotPasswordComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/shared/services/helper.service.ts");





let ForgotPasswordComponent = class ForgotPasswordComponent {
    constructor(fb, apiService, helperService) {
        this.fb = fb;
        this.apiService = apiService;
        this.helperService = helperService;
        this.createForm();
    }
    ngOnInit() {
    }
    createForm() {
        this.form = this.fb.group({
            email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].email]]
        });
    }
    onSubmit(form) {
        if (this.form.valid) {
            this.apiService.forgot(form).subscribe(res => {
                this.helperService.successAlert(res.message, 'Success');
                this.modal.nativeElement.click();
                this.form.reset();
            }, err => {
                this.helperService.errorAlert(err.error.errors[0], 'Error');
            });
        }
        else {
            this.apiService.touchAllFields(this.form);
        }
    }
};
ForgotPasswordComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('modal', { static: false })
], ForgotPasswordComponent.prototype, "modal", void 0);
ForgotPasswordComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-forgot-password',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./forgot-password.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/forgot-password/forgot-password.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./forgot-password.component.css */ "./src/app/shared/components/forgot-password/forgot-password.component.css")).default]
    })
], ForgotPasswordComponent);



/***/ }),

/***/ "./src/app/shared/components/login-form/login-form.component.css":
/*!***********************************************************************!*\
  !*** ./src/app/shared/components/login-form/login-form.component.css ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2xvZ2luLWZvcm0vbG9naW4tZm9ybS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/components/login-form/login-form.component.ts":
/*!**********************************************************************!*\
  !*** ./src/app/shared/components/login-form/login-form.component.ts ***!
  \**********************************************************************/
/*! exports provided: LoginFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginFormComponent", function() { return LoginFormComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _libs_localstorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../libs/localstorage */ "./src/app/shared/libs/localstorage.ts");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var src_app_my_account_account_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/my-account/account.service */ "./src/app/my-account/account.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/shared/services/helper.service.ts");
/* harmony import */ var _services_cart_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../services/cart.service */ "./src/app/shared/services/cart.service.ts");










let LoginFormComponent = class LoginFormComponent {
    constructor(fb, apiService, helperService, route, router, localStorage, accountService, cartService, title) {
        this.fb = fb;
        this.apiService = apiService;
        this.helperService = helperService;
        this.route = route;
        this.router = router;
        this.localStorage = localStorage;
        this.accountService = accountService;
        this.cartService = cartService;
        this.title = title;
        this.createForm();
        this.title.setTitle(this.route.snapshot.data['title']);
        this.redirectPathSubscription = this.helperService.redirectpath.asObservable().subscribe(path => this.redirectPath = path);
    }
    ngOnInit() {
    }
    createForm() {
        this.form = this.fb.group({
            email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].email]],
            password: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]]
        }, { updateOn: 'submit' });
    }
    onSubmit(form) {
        if (this.form.valid) {
            this.apiService.login(form).subscribe(res => {
                this.accountService.setLoggedInStatus(true);
                this.localStorage.setObject('user', res.result);
                this.localStorage.set('token', res.result.access_token);
                this.apiService.syncCart().subscribe(res => console.log());
                this.cartService.getCart();
                this.cartService.getCartAgain.next(true);
                this.router.navigate([this.redirectPath]);
                this.form.reset();
            }, err => {
                if (err.error.error == "Unauthorized") {
                    this.helperService.errorAlert('Invalid email or password', 'Error');
                }
                else if (err.error.message = "Validation Errors") {
                    this.helperService.errorAlert(err.error.errors[0], 'Error');
                }
            });
        }
        else {
            this.apiService.touchAllFields(this.form);
        }
    }
    ngOnDestroy() {
        this.redirectPathSubscription.unsubscribe();
    }
};
LoginFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_8__["HelperService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _libs_localstorage__WEBPACK_IMPORTED_MODULE_5__["LocalStorage"] },
    { type: src_app_my_account_account_service__WEBPACK_IMPORTED_MODULE_7__["AccountService"] },
    { type: _services_cart_service__WEBPACK_IMPORTED_MODULE_9__["CartService"] },
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_6__["Title"] }
];
LoginFormComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'login-form',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/login-form/login-form.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login-form.component.css */ "./src/app/shared/components/login-form/login-form.component.css")).default]
    })
], LoginFormComponent);



/***/ }),

/***/ "./src/app/shared/components/login-popup/login-popup.component.ts":
/*!************************************************************************!*\
  !*** ./src/app/shared/components/login-popup/login-popup.component.ts ***!
  \************************************************************************/
/*! exports provided: LoginPopupComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginPopupComponent", function() { return LoginPopupComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _libs_localstorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../libs/localstorage */ "./src/app/shared/libs/localstorage.ts");
/* harmony import */ var src_app_my_account_account_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/my-account/account.service */ "./src/app/my-account/account.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/shared/services/helper.service.ts");
/* harmony import */ var _services_cart_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../services/cart.service */ "./src/app/shared/services/cart.service.ts");









let LoginPopupComponent = class LoginPopupComponent {
    constructor(fb, apiService, helperService, route, router, localStorage, accountService, cartService) {
        this.fb = fb;
        this.apiService = apiService;
        this.helperService = helperService;
        this.route = route;
        this.router = router;
        this.localStorage = localStorage;
        this.accountService = accountService;
        this.cartService = cartService;
        this.hideForm = true;
        this.createForm();
    }
    ngOnInit() {
    }
    createForm() {
        this.form = this.fb.group({
            email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].email]],
            password: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]]
        }, { updateOn: 'submit' });
    }
    onSubmit(form) {
        let location = window.location.pathname;
        if (this.form.valid) {
            this.apiService.login(form).subscribe(res => {
                $('.login-form').slideToggle();
                this.localStorage.set('token', res.result.access_token);
                this.accountService.setLoggedInStatus(true);
                this.localStorage.setObject('user', res.result);
                this.apiService.syncCart().subscribe(res => console.log());
                this.cartService.getCart();
                this.cartService.getCartAgain.next(true);
                this.router.navigateByUrl(location);
                this.form.reset();
            }, err => {
                if (err.error.hasOwnProperty('error') && err.error.error == "Unauthorized") {
                    this.helperService.errorAlert('Invalid username / password', 'Error');
                }
                else {
                    this.helperService.errorAlert(err.error.errors[0], 'Error');
                }
            });
        }
        else {
            this.apiService.touchAllFields(this.form);
        }
    }
};
LoginPopupComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_7__["HelperService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _libs_localstorage__WEBPACK_IMPORTED_MODULE_5__["LocalStorage"] },
    { type: src_app_my_account_account_service__WEBPACK_IMPORTED_MODULE_6__["AccountService"] },
    { type: _services_cart_service__WEBPACK_IMPORTED_MODULE_8__["CartService"] }
];
LoginPopupComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-login-form',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login-popup.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/login-popup/login-popup.component.html")).default,
    })
], LoginPopupComponent);



/***/ }),

/***/ "./src/app/shared/components/not-found/not-found.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/shared/components/not-found/not-found.component.ts ***!
  \********************************************************************/
/*! exports provided: NotFoundComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotFoundComponent", function() { return NotFoundComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let NotFoundComponent = class NotFoundComponent {
    constructor() {
        this.text = 'No Product Found';
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], NotFoundComponent.prototype, "text", void 0);
NotFoundComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-not-found',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./not-found.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/not-found/not-found.component.html")).default
    })
], NotFoundComponent);



/***/ }),

/***/ "./src/app/shared/components/order-summary/order-summary.component.css":
/*!*****************************************************************************!*\
  !*** ./src/app/shared/components/order-summary/order-summary.component.css ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL29yZGVyLXN1bW1hcnkvb3JkZXItc3VtbWFyeS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/components/order-summary/order-summary.component.ts":
/*!****************************************************************************!*\
  !*** ./src/app/shared/components/order-summary/order-summary.component.ts ***!
  \****************************************************************************/
/*! exports provided: OrderSummaryComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrderSummaryComponent", function() { return OrderSummaryComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let OrderSummaryComponent = class OrderSummaryComponent {
    constructor() {
        this.isCart = true;
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], OrderSummaryComponent.prototype, "order", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], OrderSummaryComponent.prototype, "isCart", void 0);
OrderSummaryComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-order-summary',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./order-summary.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/order-summary/order-summary.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./order-summary.component.css */ "./src/app/shared/components/order-summary/order-summary.component.css")).default]
    })
], OrderSummaryComponent);



/***/ }),

/***/ "./src/app/shared/components/perk/Perks.ts":
/*!*************************************************!*\
  !*** ./src/app/shared/components/perk/Perks.ts ***!
  \*************************************************/
/*! exports provided: Perks */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Perks", function() { return Perks; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class Perks {
}


/***/ }),

/***/ "./src/app/shared/components/perk/perk.component.css":
/*!***********************************************************!*\
  !*** ./src/app/shared/components/perk/perk.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3BlcmsvcGVyay5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/components/perk/perk.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/shared/components/perk/perk.component.ts ***!
  \**********************************************************/
/*! exports provided: PerkComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PerkComponent", function() { return PerkComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _Perks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Perks */ "./src/app/shared/components/perk/Perks.ts");



let PerkComponent = class PerkComponent {
    constructor() {
        this.perks = [_Perks__WEBPACK_IMPORTED_MODULE_2__["Perks"]];
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], PerkComponent.prototype, "perks", void 0);
PerkComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-perk',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./perk.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/perk/perk.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./perk.component.css */ "./src/app/shared/components/perk/perk.component.css")).default]
    })
], PerkComponent);



/***/ }),

/***/ "./src/app/shared/components/product-filters/product-filters.component.css":
/*!*********************************************************************************!*\
  !*** ./src/app/shared/components/product-filters/product-filters.component.css ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (" \n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3Byb2R1Y3QtZmlsdGVycy9wcm9kdWN0LWZpbHRlcnMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/shared/components/product-filters/product-filters.component.ts":
/*!********************************************************************************!*\
  !*** ./src/app/shared/components/product-filters/product-filters.component.ts ***!
  \********************************************************************************/
/*! exports provided: ProductFiltersComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProductFiltersComponent", function() { return ProductFiltersComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



const qs = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
let ProductFiltersComponent = class ProductFiltersComponent {
    constructor(router, route, elementRef) {
        this.router = router;
        this.route = route;
        this.elementRef = elementRef;
        this.filters = [];
        this.categoryPriceFilters = [];
        this.priceRanges = [];
        this.occasions = [];
        this.filterProducts = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"];
        this.filterOption = {};
        this.options = {};
        this.queryParams = {};
        this.ocassionSelected = [];
        this.selectedInsta = false;
        this.maxPriceSelected = (event, filter, maxPrice) => {
            debugger;
            if (event.target.checked) {
                filter.checked = true;
                this.options.price_above = maxPrice;
            }
            else {
                filter.checked = false;
                delete this.options.price_above;
            }
            this.pushPath();
        };
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        if (changes.filters && changes.filters.currentValue.length > 0 || changes.priceRanges) {
            this.route.queryParamMap.subscribe(params => {
                this.filterOption = params['params'];
                let opt = this.filterOption;
                Object.keys(opt).forEach(option => {
                    this.options[option] = opt[option].split(',');
                });
                Object.keys(this.filterOption).forEach(opt => {
                    if (opt == 'occasions') {
                        let occasions = this.filterOption[opt].split(',');
                        let occasionIndex = this.filters.findIndex(x => x.product_option == 'By Occasion');
                        this.filters[occasionIndex].option_values.forEach(value => {
                            if (occasions.find(x => x == value.id)) {
                                value.checked = true;
                            }
                        });
                    }
                    else if (opt == 'price') {
                        let prices = this.filterOption[opt].split(',');
                        // this.selectedPrice = prices[1]
                        let index = this.filters.findIndex(x => x.product_option == 'Prices');
                        this.filters[index].option_values.forEach(item => {
                            let price = item.price.toString();
                            if (prices.includes(price)) {
                                item.checked = true;
                            }
                        });
                    }
                    else if (opt == 'price_above') {
                        let index = this.filters.findIndex(x => x.product_option == 'Prices');
                        this.filters[index].option_values[this.filters[index].option_values.length - 1].checked = true;
                    }
                    else if (opt == 'uploadedToInsta') {
                        this.selectedInsta = true;
                    }
                    else if (this.filters.length > 0 && opt != 'page' && opt != 'orderBy' && opt != 'sort') {
                        let index = this.filters.findIndex(x => x.product_option == opt);
                        this.filters[index].option_values.forEach(value => {
                            if (this.options[opt].find(x => x == value.id)) {
                                value.checked = true;
                            }
                        });
                    }
                });
            });
        }
    }
    optionChecked(event) {
        let value = event.target.value.split('|');
        if (event.target.checked) {
            if (this.options.hasOwnProperty(value[0]) && this.options[value[0]].length != 0) {
                this.options[value[0]].push(value[1]);
            }
            else {
                this.options[value[0]] = [value[1]];
            }
        }
        else {
            let index = this.options[value[0]].findIndex(x => x == value[1]);
            this.options[value[0]].splice(index, 1);
        }
        this.pushPath();
    }
    pushPath() {
        let opt = {};
        Object.keys(this.options).forEach(option => {
            if (this.options[option].length > 0)
                opt[option] = this.options[option].join(',');
            else if (this.options[option].length != 0)
                opt[option] = this.options[option];
        });
        this.filterOption = opt;
        this.filterOption.page = 1;
        this.filterProducts.emit(this.filterOption);
        this.router.navigate([], { queryParams: this.filterOption });
    }
    priceSelected(event, item) {
        if (event.target.checked) {
            item.checked = true;
        }
        else {
            item.checked = false;
        }
        let prices = [];
        let priceFilters = this.filters.find(x => x.product_option == 'Prices');
        priceFilters.option_values.forEach((x, i) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (x.checked && i != priceFilters.option_values.length - 1) {
                prices.push(x.price);
            }
        }));
        this.options.price = prices;
        // console.log('options', this.options.price)
        this.pushPath();
    }
    byInsta() {
        let opt = {};
        Object.keys(this.options).forEach(option => {
            if (this.options[option].length > 0)
                opt[option] = this.options[option].join(',');
        });
        this.selectedInsta = true;
        this.filterOption = opt;
        this.filterOption.page = 1;
        this.filterOption['uploadedToInsta'] = 1;
        this.filterProducts.emit(this.filterOption);
        this.router.navigate([], { queryParams: this.filterOption });
    }
    clearPrice() {
        let opt = {};
        Object.keys(this.filterOption).forEach(option => {
            if (option != 'price')
                opt[option] = this.filterOption[option];
        });
        this.selectedInsta = false;
        this.filterProducts.emit(opt);
        this.router.navigate([], { queryParams: opt });
    }
    resetAll() {
        this.options = [];
        this.filterProducts.emit({});
        this.router.navigate([]);
    }
    isEmpty(object) {
        return Object.keys(object).length === 0;
    }
};
ProductFiltersComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ProductFiltersComponent.prototype, "filters", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ProductFiltersComponent.prototype, "categoryPriceFilters", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ProductFiltersComponent.prototype, "priceRanges", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ProductFiltersComponent.prototype, "occasions", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ProductFiltersComponent.prototype, "productsLength", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], ProductFiltersComponent.prototype, "filterProducts", void 0);
ProductFiltersComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-product-filters',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./product-filters.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-filters/product-filters.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./product-filters.component.css */ "./src/app/shared/components/product-filters/product-filters.component.css")).default]
    })
], ProductFiltersComponent);



/***/ }),

/***/ "./src/app/shared/components/product-options/product-options.component.css":
/*!*********************************************************************************!*\
  !*** ./src/app/shared/components/product-options/product-options.component.css ***!
  \*********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3Byb2R1Y3Qtb3B0aW9ucy9wcm9kdWN0LW9wdGlvbnMuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/shared/components/product-options/product-options.component.ts":
/*!********************************************************************************!*\
  !*** ./src/app/shared/components/product-options/product-options.component.ts ***!
  \********************************************************************************/
/*! exports provided: ProductOptionsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProductOptionsComponent", function() { return ProductOptionsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ProductOptionsComponent = class ProductOptionsComponent {
    constructor() {
        this.options = [];
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ProductOptionsComponent.prototype, "options", void 0);
ProductOptionsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-product-options',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./product-options.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-options/product-options.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./product-options.component.css */ "./src/app/shared/components/product-options/product-options.component.css")).default]
    })
], ProductOptionsComponent);



/***/ }),

/***/ "./src/app/shared/components/product-price/product-price.component.css":
/*!*****************************************************************************!*\
  !*** ./src/app/shared/components/product-price/product-price.component.css ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3Byb2R1Y3QtcHJpY2UvcHJvZHVjdC1wcmljZS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/components/product-price/product-price.component.ts":
/*!****************************************************************************!*\
  !*** ./src/app/shared/components/product-price/product-price.component.ts ***!
  \****************************************************************************/
/*! exports provided: ProductPriceComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProductPriceComponent", function() { return ProductPriceComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ProductPriceComponent = class ProductPriceComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ProductPriceComponent.prototype, "product", void 0);
ProductPriceComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-product-price',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./product-price.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/product-price/product-price.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./product-price.component.css */ "./src/app/shared/components/product-price/product-price.component.css")).default]
    })
], ProductPriceComponent);



/***/ }),

/***/ "./src/app/shared/components/recent-blogs/recent-blogs.component.css":
/*!***************************************************************************!*\
  !*** ./src/app/shared/components/recent-blogs/recent-blogs.component.css ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3JlY2VudC1ibG9ncy9yZWNlbnQtYmxvZ3MuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/shared/components/recent-blogs/recent-blogs.component.ts":
/*!**************************************************************************!*\
  !*** ./src/app/shared/components/recent-blogs/recent-blogs.component.ts ***!
  \**************************************************************************/
/*! exports provided: RecentBlogsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RecentBlogsComponent", function() { return RecentBlogsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/shared/services/helper.service.ts");




let RecentBlogsComponent = class RecentBlogsComponent {
    constructor(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    ngOnInit() {
        this.getRecentPosts();
    }
    getRecentPosts() {
        this.apiService.recentPosts().subscribe(res => {
            this.recentPost = res.result;
        }, err => {
            this.helperService.errorAlert('Something went wrong', 'Error');
        });
    }
};
RecentBlogsComponent.ctorParameters = () => [
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_3__["HelperService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], RecentBlogsComponent.prototype, "currentBlog", void 0);
RecentBlogsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-recent-blogs',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./recent-blogs.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/recent-blogs/recent-blogs.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./recent-blogs.component.css */ "./src/app/shared/components/recent-blogs/recent-blogs.component.css")).default]
    })
], RecentBlogsComponent);



/***/ }),

/***/ "./src/app/shared/components/related-products/related-products.component.css":
/*!***********************************************************************************!*\
  !*** ./src/app/shared/components/related-products/related-products.component.css ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3JlbGF0ZWQtcHJvZHVjdHMvcmVsYXRlZC1wcm9kdWN0cy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/components/related-products/related-products.component.ts":
/*!**********************************************************************************!*\
  !*** ./src/app/shared/components/related-products/related-products.component.ts ***!
  \**********************************************************************************/
/*! exports provided: RelatedProductsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RelatedProductsComponent", function() { return RelatedProductsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let RelatedProductsComponent = class RelatedProductsComponent {
    constructor() {
        this.products = [];
        this.getProduct = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"];
    }
    ngOnInit() {
    }
    onClickProduct(product) {
        this.getProduct.emit(product.slug);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], RelatedProductsComponent.prototype, "products", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], RelatedProductsComponent.prototype, "category", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], RelatedProductsComponent.prototype, "getProduct", void 0);
RelatedProductsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-related-products',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./related-products.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/related-products/related-products.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./related-products.component.css */ "./src/app/shared/components/related-products/related-products.component.css")).default]
    })
], RelatedProductsComponent);



/***/ }),

/***/ "./src/app/shared/components/review-address/review-address.component.css":
/*!*******************************************************************************!*\
  !*** ./src/app/shared/components/review-address/review-address.component.css ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3Jldmlldy1hZGRyZXNzL3Jldmlldy1hZGRyZXNzLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/shared/components/review-address/review-address.component.ts":
/*!******************************************************************************!*\
  !*** ./src/app/shared/components/review-address/review-address.component.ts ***!
  \******************************************************************************/
/*! exports provided: ReviewAddressComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReviewAddressComponent", function() { return ReviewAddressComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ReviewAddressComponent = class ReviewAddressComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ReviewAddressComponent.prototype, "data", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ReviewAddressComponent.prototype, "title", void 0);
ReviewAddressComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-review-address',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./review-address.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/review-address/review-address.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./review-address.component.css */ "./src/app/shared/components/review-address/review-address.component.css")).default]
    })
], ReviewAddressComponent);



/***/ }),

/***/ "./src/app/shared/components/reviews/reviews.component.css":
/*!*****************************************************************!*\
  !*** ./src/app/shared/components/reviews/reviews.component.css ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3Jldmlld3MvcmV2aWV3cy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/components/reviews/reviews.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/shared/components/reviews/reviews.component.ts ***!
  \****************************************************************/
/*! exports provided: ReviewsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReviewsComponent", function() { return ReviewsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ReviewsComponent = class ReviewsComponent {
    constructor() {
        this.limit = 3;
    }
    ngOnInit() {
    }
    viewMore() {
        this.limit += 3;
        console.log('limit', this.limit);
        console.log('reviews length', this.reviews.length);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ReviewsComponent.prototype, "reviews", void 0);
ReviewsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-reviews',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./reviews.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/reviews/reviews.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./reviews.component.css */ "./src/app/shared/components/reviews/reviews.component.css")).default]
    })
], ReviewsComponent);



/***/ }),

/***/ "./src/app/shared/components/sidebar-menu/sidebar-menu.component.css":
/*!***************************************************************************!*\
  !*** ./src/app/shared/components/sidebar-menu/sidebar-menu.component.css ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3NpZGViYXItbWVudS9zaWRlYmFyLW1lbnUuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/shared/components/sidebar-menu/sidebar-menu.component.ts":
/*!**************************************************************************!*\
  !*** ./src/app/shared/components/sidebar-menu/sidebar-menu.component.ts ***!
  \**************************************************************************/
/*! exports provided: SidebarMenuComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SidebarMenuComponent", function() { return SidebarMenuComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let SidebarMenuComponent = class SidebarMenuComponent {
    constructor(router) {
        this.router = router;
        this.menus = [];
        this.routePage = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    ngOnInit() {
    }
    linkClick(link) {
        this.slug = link;
        //this.router.navigate(['/post/' + this.slug]) 
        this.routePage.emit(link);
    }
};
SidebarMenuComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SidebarMenuComponent.prototype, "menus", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], SidebarMenuComponent.prototype, "slug", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])()
], SidebarMenuComponent.prototype, "routePage", void 0);
SidebarMenuComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-sidebar-menu',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./sidebar-menu.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/sidebar-menu/sidebar-menu.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./sidebar-menu.component.css */ "./src/app/shared/components/sidebar-menu/sidebar-menu.component.css")).default]
    })
], SidebarMenuComponent);



/***/ }),

/***/ "./src/app/shared/components/subscribe/subscribe.component.css":
/*!*********************************************************************!*\
  !*** ./src/app/shared/components/subscribe/subscribe.component.css ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3N1YnNjcmliZS9zdWJzY3JpYmUuY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/app/shared/components/subscribe/subscribe.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/shared/components/subscribe/subscribe.component.ts ***!
  \********************************************************************/
/*! exports provided: SubscribeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubscribeComponent", function() { return SubscribeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../services/helper.service */ "./src/app/shared/services/helper.service.ts");





let SubscribeComponent = class SubscribeComponent {
    constructor(fb, apiService, helperService) {
        this.fb = fb;
        this.apiService = apiService;
        this.helperService = helperService;
        this.form = this.fb.group({
            email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].email]],
            name: ''
        });
    }
    ngOnInit() {
    }
    onSubmit(form) {
        if (this.form.valid) {
            this.apiService.subscribe(form).subscribe(res => {
                this.form.reset();
                this.helperService.successAlert(res.message, 'Success');
            }, err => {
                this.helperService.errorAlert(err.error.message, 'Error');
            });
        }
        else {
            this.apiService.touchAllFields(this.form);
        }
    }
};
SubscribeComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_4__["HelperService"] }
];
SubscribeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-subscribe',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./subscribe.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/subscribe/subscribe.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./subscribe.component.css */ "./src/app/shared/components/subscribe/subscribe.component.css")).default]
    })
], SubscribeComponent);



/***/ }),

/***/ "./src/app/shared/components/team/team.component.css":
/*!***********************************************************!*\
  !*** ./src/app/shared/components/team/team.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL3RlYW0vdGVhbS5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/components/team/team.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/shared/components/team/team.component.ts ***!
  \**********************************************************/
/*! exports provided: TeamComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TeamComponent", function() { return TeamComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let TeamComponent = class TeamComponent {
    constructor() {
        this.team = [];
    }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], TeamComponent.prototype, "team", void 0);
TeamComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-team',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./team.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/team/team.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./team.component.css */ "./src/app/shared/components/team/team.component.css")).default]
    })
], TeamComponent);



/***/ }),

/***/ "./src/app/shared/constants/Constants.ts":
/*!***********************************************!*\
  !*** ./src/app/shared/constants/Constants.ts ***!
  \***********************************************/
/*! exports provided: Constants */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Constants", function() { return Constants; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const Constants = {
    logo: '/assets/images/kate-and-adam.png'
};


/***/ }),

/***/ "./src/app/shared/directives/expand-lists.directive.ts":
/*!*************************************************************!*\
  !*** ./src/app/shared/directives/expand-lists.directive.ts ***!
  \*************************************************************/
/*! exports provided: ExpandListsDirective */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpandListsDirective", function() { return ExpandListsDirective; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ExpandListsDirective = class ExpandListsDirective {
    constructor(element, renderer) {
        this.element = element;
        this.renderer = renderer;
    }
    ngAfterContentInit() {
        if (this.values) {
            let checkItem = this.values.find(x => x.checked == true);
            if (checkItem) {
                this.renderer.setAttribute(this.element.nativeElement, 'style', 'display:block');
                if (this.icon)
                    this.renderer.addClass(this.element.nativeElement, this.icon);
            }
        }
    }
};
ExpandListsDirective.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Renderer2"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ExpandListsDirective.prototype, "values", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])()
], ExpandListsDirective.prototype, "icon", void 0);
ExpandListsDirective = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Directive"])({
        selector: '[appExpandLists]'
    })
], ExpandListsDirective);



/***/ }),

/***/ "./src/app/shared/footer/footer.component.css":
/*!****************************************************!*\
  !*** ./src/app/shared/footer/footer.component.css ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9mb290ZXIvZm9vdGVyLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/shared/footer/footer.component.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/footer/footer.component.ts ***!
  \***************************************************/
/*! exports provided: FooterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FooterComponent", function() { return FooterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _libs_localstorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../libs/localstorage */ "./src/app/shared/libs/localstorage.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../services/helper.service */ "./src/app/shared/services/helper.service.ts");








let FooterComponent = class FooterComponent {
    constructor(fb, apiService, helperService, router, localStorage, platformId, changeDetectorRef) {
        this.fb = fb;
        this.apiService = apiService;
        this.helperService = helperService;
        this.router = router;
        this.localStorage = localStorage;
        this.platformId = platformId;
        this.changeDetectorRef = changeDetectorRef;
        this.showFooter = false;
        this.footer_menu_1 = [];
        this.footer_menu_2 = [];
        this.email = 'support@dcjewelery.com';
        this.phone = '743-5678-559';
        this.logo = '';
        this.newsletterFormElements();
    }
    ngOnInit() {
        this.getMenu('footer_menu_1');
        this.getMenu('footer_menu_2');
        this.initFooterSettings();
        this.subscription = this.helperService.getFooterVisibility().subscribe(status => {
            this.showFooter = status;
            this.changeDetectorRef.detectChanges();
        });
    }
    initFooterSettings() {
        if (Object(_angular_common__WEBPACK_IMPORTED_MODULE_6__["isPlatformBrowser"])(this.platformId)) {
            const setings = this.localStorage.getObject('site_settings');
            if (setings.length) {
                this.email = setings.find(x => x.key == 'site.email').value;
                this.phone = setings.find(x => x.key == 'site.phone').value;
                this.logo = setings.find(x => x.key == 'site.logo').value;
            }
        }
    }
    newsletterFormElements() {
        this.newsLetterForm = this.fb.group({
            email: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].email]],
            agree: ['']
        }, { updateOn: 'submit' });
    }
    onSubmitNewsletter(form) {
        if (this.newsLetterForm.valid) {
            this.apiService.subscribe(form).subscribe(res => {
                this.newsLetterForm.reset();
                this.helperService.successAlert(res.message, 'Success');
            }, err => {
                this.helperService.errorAlert(err.error.message, 'Error');
            });
        }
        else {
            this.apiService.touchAllFields(this.newsLetterForm);
        }
    }
    getMenu(menu) {
        this.apiService.getMenu(menu).subscribe(res => {
            this[menu] = res.result.items;
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
};
FooterComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_7__["HelperService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] },
    { type: _libs_localstorage__WEBPACK_IMPORTED_MODULE_5__["LocalStorage"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"],] }] },
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] }
];
FooterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-footer',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./footer.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/footer/footer.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./footer.component.css */ "./src/app/shared/footer/footer.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](5, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"]))
], FooterComponent);



/***/ }),

/***/ "./src/app/shared/header/header.component.css":
/*!****************************************************!*\
  !*** ./src/app/shared/header/header.component.css ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9oZWFkZXIvaGVhZGVyLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/shared/header/header.component.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/header/header.component.ts ***!
  \***************************************************/
/*! exports provided: HeaderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderComponent", function() { return HeaderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _libs_localstorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../libs/localstorage */ "./src/app/shared/libs/localstorage.ts");
/* harmony import */ var _auth_auth_service___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../auth/auth.service  */ "./src/app/shared/auth/auth.service .ts");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services_cart_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../services/cart.service */ "./src/app/shared/services/cart.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var src_app_my_account_account_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/app/my-account/account.service */ "./src/app/my-account/account.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../services/helper.service */ "./src/app/shared/services/helper.service.ts");










let HeaderComponent = class HeaderComponent {
    constructor(localStorage, auth, apiServices, router, cartService, platformId, accountService, helperService) {
        // if(isPlatformBrowser(this.platformId)) {
        //   if (this.auth.isAuthenticated()) {
        //     this.isLoggedIn = !this.isLoggedIn
        //   }
        // }
        this.localStorage = localStorage;
        this.auth = auth;
        this.apiServices = apiServices;
        this.router = router;
        this.cartService = cartService;
        this.platformId = platformId;
        this.accountService = accountService;
        this.helperService = helperService;
        this.logo = '';
        this.isLoggedIn = false;
        this.showSearch = false;
        this.suggestProducts = [];
        this.accountService.currentLoggedInStatus.subscribe(isLoggedIn => this.isLoggedIn = isLoggedIn);
        this.cartService.currentCartCount.subscribe(count => this.cartCount = count);
    }
    ngOnInit() {
        if (Object(_angular_common__WEBPACK_IMPORTED_MODULE_7__["isPlatformBrowser"])(this.platformId)) {
            this.getContactDetails();
        }
    }
    search(ev) {
        let value = ev.target.value;
        if (!value) {
            this.searchRecords = null;
        }
        else {
            this.apiServices.search(value, 20).subscribe(res => {
                this.searchRecords = [];
                if (res.result.products.length > 0) {
                    this.searchRecords = res.result.products;
                }
                // else if(res.suggests.hasOwnProperty('_')) {
                //   this.searchRecords = res.suggests._
                // } 
                else {
                    this.searchRecords = [];
                    this.apiServices.productSuggestions().subscribe(response => {
                        this.suggestProducts = response.result;
                    });
                }
            });
        }
    }
    getContactDetails() {
        const settings = this.localStorage.getObject('site_settings');
        if (settings != undefined) {
            this.logo = settings.find(x => x.key == 'site.logo').value;
        }
    }
    logout() {
        this.apiServices.logout().subscribe(res => {
            this.accountService.setLoggedInStatus(false);
            this.localStorage.remove('token');
            this.localStorage.remove('user');
            this.localStorage.remove('cart');
            this.cartService.setCartCount(0);
            this.router.navigate(['/']);
        });
    }
    goToCart() {
        if (this.cartCount) {
            this.router.navigate(['/cart']);
        }
        else {
            const msg = `<h5>Your cart is empty</h5> <p>Looks like you haven’t added any item to you cart yet.</p>`;
            this.helperService.successAlert(msg, '', '/assets/images/empty-cart.png', '');
        }
    }
    goToProfile() {
        window.location.href = '/account';
        // this.router.navigateByUrl('/account')
    }
    gotoLink(link) {
        this.router.navigateByUrl(link);
    }
    searchDetailPage() {
        if (this.searchQuery != '') {
            this.router.navigate(['/search-details'], { queryParams: { query: this.searchQuery } });
        }
    }
};
HeaderComponent.ctorParameters = () => [
    { type: _libs_localstorage__WEBPACK_IMPORTED_MODULE_2__["LocalStorage"] },
    { type: _auth_auth_service___WEBPACK_IMPORTED_MODULE_3__["AuthService"] },
    { type: _api_service__WEBPACK_IMPORTED_MODULE_4__["ApiService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_5__["Router"] },
    { type: _services_cart_service__WEBPACK_IMPORTED_MODULE_6__["CartService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"],] }] },
    { type: src_app_my_account_account_service__WEBPACK_IMPORTED_MODULE_8__["AccountService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_9__["HelperService"] }
];
HeaderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-header',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/header/header.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header.component.css */ "./src/app/shared/header/header.component.css")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](5, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"]))
], HeaderComponent);



/***/ }),

/***/ "./src/app/shared/libs/localstorage.ts":
/*!*********************************************!*\
  !*** ./src/app/shared/libs/localstorage.ts ***!
  \*********************************************/
/*! exports provided: LocalStorage */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalStorage", function() { return LocalStorage; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");



const KEY_PREFIX = "ka";
// declare var localStorage: any
let LocalStorage = class LocalStorage {
    constructor(platformId) {
        this.platformId = platformId;
        if (Object(_angular_common__WEBPACK_IMPORTED_MODULE_2__["isPlatformBrowser"])(this.platformId)) {
            if (!localStorage) {
                throw new Error('Current browser does not support Local Storage');
            }
            this.localStorage = localStorage;
        }
    }
    generateStorageKey(key) {
        return `${KEY_PREFIX}_${key}`;
    }
    set(key, value) {
        let storageKey = this.generateStorageKey(key);
        this.localStorage[storageKey] = value;
    }
    get(key) {
        let storageKey = this.generateStorageKey(key);
        return this.localStorage[storageKey] || false;
    }
    setObject(key, value) {
        let storageKey = this.generateStorageKey(key);
        this.localStorage[storageKey] = JSON.stringify(value);
    }
    getObject(key) {
        let storageKey = this.generateStorageKey(key);
        return JSON.parse(this.localStorage[storageKey] || '{}');
    }
    remove(key) {
        let storageKey = this.generateStorageKey(key);
        this.localStorage.removeItem(storageKey);
    }
};
LocalStorage.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"],] }] }
];
LocalStorage = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_core__WEBPACK_IMPORTED_MODULE_1__["PLATFORM_ID"]))
], LocalStorage);



/***/ }),

/***/ "./src/app/shared/pipes/excerpt.pipe.ts":
/*!**********************************************!*\
  !*** ./src/app/shared/pipes/excerpt.pipe.ts ***!
  \**********************************************/
/*! exports provided: ExcerptPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExcerptPipe", function() { return ExcerptPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ExcerptPipe = class ExcerptPipe {
    transform(value, length = 40) {
        if (value) {
            value = value.substring(0, length);
        }
        return value;
    }
};
ExcerptPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'excerpt'
    })
], ExcerptPipe);



/***/ }),

/***/ "./src/app/shared/pipes/format-date.pipe.ts":
/*!**************************************************!*\
  !*** ./src/app/shared/pipes/format-date.pipe.ts ***!
  \**************************************************/
/*! exports provided: FormatDatePipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormatDatePipe", function() { return FormatDatePipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let FormatDatePipe = class FormatDatePipe {
    transform(value, ...args) {
        return new Date(value.replace(/-/g, '/'));
    }
};
FormatDatePipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'formatDate'
    })
], FormatDatePipe);



/***/ }),

/***/ "./src/app/shared/pipes/image-url.pipe.ts":
/*!************************************************!*\
  !*** ./src/app/shared/pipes/image-url.pipe.ts ***!
  \************************************************/
/*! exports provided: ImageUrlPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageUrlPipe", function() { return ImageUrlPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");



let ImageUrlPipe = class ImageUrlPipe {
    transform(value, baseUrl = false) {
        this.storagePath = src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].storageUrl;
        if (value != null && !baseUrl) {
            return this.storagePath + value;
        }
        else {
            return src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].base_url + value;
        }
    }
};
ImageUrlPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'imageUrl'
    })
], ImageUrlPipe);



/***/ }),

/***/ "./src/app/shared/pipes/safe-html.pipe.ts":
/*!************************************************!*\
  !*** ./src/app/shared/pipes/safe-html.pipe.ts ***!
  \************************************************/
/*! exports provided: SafeHtmlPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SafeHtmlPipe", function() { return SafeHtmlPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");



let SafeHtmlPipe = class SafeHtmlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, ...args) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
};
SafeHtmlPipe.ctorParameters = () => [
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["DomSanitizer"] }
];
SafeHtmlPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'safeHtml'
    })
], SafeHtmlPipe);



/***/ }),

/***/ "./src/app/shared/pipes/sanitize-html.pipe.ts":
/*!****************************************************!*\
  !*** ./src/app/shared/pipes/sanitize-html.pipe.ts ***!
  \****************************************************/
/*! exports provided: SanitizeHTMLPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SanitizeHTMLPipe", function() { return SanitizeHTMLPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");



let SanitizeHTMLPipe = class SanitizeHTMLPipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(value, ...args) {
        return this.domSanitizer.bypassSecurityTrustHtml(value);
    }
};
SanitizeHTMLPipe.ctorParameters = () => [
    { type: _angular_platform_browser__WEBPACK_IMPORTED_MODULE_2__["DomSanitizer"] }
];
SanitizeHTMLPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'sanitizeHTML'
    })
], SanitizeHTMLPipe);



/***/ }),

/***/ "./src/app/shared/services/cart.service.ts":
/*!*************************************************!*\
  !*** ./src/app/shared/services/cart.service.ts ***!
  \*************************************************/
/*! exports provided: CartService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CartService", function() { return CartService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _libs_localstorage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../libs/localstorage */ "./src/app/shared/libs/localstorage.ts");





let CartService = class CartService {
    constructor(apiService, localStorage) {
        this.apiService = apiService;
        this.localStorage = localStorage;
        this.cartCount = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](0);
        this.currentCartCount = this.cartCount.asObservable();
        this.cart = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]({});
        this.currentCart = this.cart.asObservable();
        this.checkoutData = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]({});
        this.currentCheckoutData = this.checkoutData.asObservable();
        this.order = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]({});
        this.currentOrder = this.order.asObservable();
        this.getCartAgain = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](false);
        this.isCartFetchAgain = this.getCartAgain.asObservable();
        this.orderMessage = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]('');
    }
    setCartCount(count) {
        this.cartCount.next(count);
    }
    setCart(data) {
        this.cart.next(data);
    }
    getCartCount() {
        return this.cartCount;
    }
    setOrder(order) {
        this.order.next(order);
    }
    setCheckoutData(data) {
        this.checkoutData.next(data);
    }
    getCart() {
        this.apiService.mycart().subscribe(res => {
            // this.cart = res.result
            this.localStorage.setObject('cart', res.result);
            let cartCount = 0;
            res.result.products.forEach(product => {
                cartCount = Number(cartCount) + Number(product.quantity);
            });
            this.cart.next(res.result);
            this.setCartCount(cartCount);
            //console.clear();
        }, err => {
            this.localStorage.remove('cart');
            this.cart = null;
            this.setCartCount(0);
            //this.router.navigate(['/'])
            // console.clear();
        });
    }
    getOrderMessage() {
        return this.orderMessage.asObservable();
    }
};
CartService.ctorParameters = () => [
    { type: _api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _libs_localstorage__WEBPACK_IMPORTED_MODULE_4__["LocalStorage"] }
];
CartService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], CartService);



/***/ }),

/***/ "./src/app/shared/services/helper.service.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/services/helper.service.ts ***!
  \***************************************************/
/*! exports provided: HelperService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HelperService", function() { return HelperService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! sweetalert2 */ "./node_modules/sweetalert2/dist/sweetalert2.all.js");
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");




let HelperService = class HelperService {
    constructor() {
        this.showFooter = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](false);
        this.footerVisibility = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](false);
        this.redirectpath = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"]('/account/profile');
    }
    successAlert(message = '', title = '', imageUrl = '', icon = 'success') {
        sweetalert2__WEBPACK_IMPORTED_MODULE_2___default.a.fire({
            title: title,
            html: message,
            imageUrl: imageUrl,
            icon: icon,
            confirmButtonText: 'OK',
            customClass: {
                container: 'container-class',
                popup: 'popup-class',
                header: 'header-class',
                title: 'title-class',
                closeButton: 'close-button-class',
                icon: 'icon-class',
                image: 'image-class',
                content: 'content-class',
                input: 'input-class',
                actions: 'actions-class',
                confirmButton: 'confirm-button-class',
                cancelButton: 'cancel-button-class',
                footer: 'footer-class'
            }
        });
    }
    errorAlert(message, title = 'Error') {
        sweetalert2__WEBPACK_IMPORTED_MODULE_2___default.a.fire({
            title: title,
            html: message,
            icon: 'error',
            confirmButtonText: 'Close',
            customClass: {
                container: 'container-class',
                popup: 'popup-class',
                header: 'header-class',
                title: 'title-class',
                closeButton: 'close-button-class',
                icon: 'icon-class',
                image: 'image-class',
                content: 'content-class',
                input: 'input-class',
                actions: 'actions-class',
                confirmButton: 'confirm-button-class',
                cancelButton: 'cancel-button-class',
                footer: 'footer-class'
            }
        });
    }
    setFooterVisibility(status) {
        this.showFooter.next(status);
    }
    getFooterVisibility() {
        return this.showFooter.asObservable();
    }
};
HelperService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], HelperService);



/***/ }),

/***/ "./src/app/shared/services/meta-tags.service.ts":
/*!******************************************************!*\
  !*** ./src/app/shared/services/meta-tags.service.ts ***!
  \******************************************************/
/*! exports provided: MetaTagsService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MetaTagsService", function() { return MetaTagsService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");



let MetaTagsService = class MetaTagsService {
    constructor() {
        this.metaTags = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"]({});
        this.currentMeta = this.metaTags.asObservable();
    }
    isEmpty(object) {
        return Object.keys(object).length === 0;
    }
    setMetaTags(data) {
        this.metaTags.next(data);
    }
};
MetaTagsService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], MetaTagsService);



/***/ }),

/***/ "./src/app/shared/shared.module.ts":
/*!*****************************************!*\
  !*** ./src/app/shared/shared.module.ts ***!
  \*****************************************/
/*! exports provided: SharedModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharedModule", function() { return SharedModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _header_header_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./header/header.component */ "./src/app/shared/header/header.component.ts");
/* harmony import */ var _footer_footer_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./footer/footer.component */ "./src/app/shared/footer/footer.component.ts");
/* harmony import */ var _side_nav_side_nav_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./side-nav/side-nav.component */ "./src/app/shared/side-nav/side-nav.component.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _components_category_category_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/category/category.component */ "./src/app/shared/components/category/category.component.ts");
/* harmony import */ var _pipes_image_url_pipe__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./pipes/image-url.pipe */ "./src/app/shared/pipes/image-url.pipe.ts");
/* harmony import */ var _components_perk_perk_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/perk/perk.component */ "./src/app/shared/components/perk/perk.component.ts");
/* harmony import */ var _components_team_team_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/team/team.component */ "./src/app/shared/components/team/team.component.ts");
/* harmony import */ var _libs_localstorage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./libs/localstorage */ "./src/app/shared/libs/localstorage.ts");
/* harmony import */ var _components_contact_form_contact_form_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/contact-form/contact-form.component */ "./src/app/shared/components/contact-form/contact-form.component.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _components_faq_faq_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/faq/faq.component */ "./src/app/shared/components/faq/faq.component.ts");
/* harmony import */ var _components_sidebar_menu_sidebar_menu_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/sidebar-menu/sidebar-menu.component */ "./src/app/shared/components/sidebar-menu/sidebar-menu.component.ts");
/* harmony import */ var _components_recent_blogs_recent_blogs_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/recent-blogs/recent-blogs.component */ "./src/app/shared/components/recent-blogs/recent-blogs.component.ts");
/* harmony import */ var _components_subscribe_subscribe_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./components/subscribe/subscribe.component */ "./src/app/shared/components/subscribe/subscribe.component.ts");
/* harmony import */ var _components_login_popup_login_popup_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/login-popup/login-popup.component */ "./src/app/shared/components/login-popup/login-popup.component.ts");
/* harmony import */ var _auth_auth_service___WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./auth/auth.service  */ "./src/app/shared/auth/auth.service .ts");
/* harmony import */ var _auth_auth_guard_service__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./auth/auth-guard.service */ "./src/app/shared/auth/auth-guard.service.ts");
/* harmony import */ var _components_forgot_password_forgot_password_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/forgot-password/forgot-password.component */ "./src/app/shared/components/forgot-password/forgot-password.component.ts");
/* harmony import */ var _pipes_excerpt_pipe__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./pipes/excerpt.pipe */ "./src/app/shared/pipes/excerpt.pipe.ts");
/* harmony import */ var _components_product_filters_product_filters_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/product-filters/product-filters.component */ "./src/app/shared/components/product-filters/product-filters.component.ts");
/* harmony import */ var _pipes_safe_html_pipe__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./pipes/safe-html.pipe */ "./src/app/shared/pipes/safe-html.pipe.ts");
/* harmony import */ var _components_login_form_login_form_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./components/login-form/login-form.component */ "./src/app/shared/components/login-form/login-form.component.ts");
/* harmony import */ var _components_related_products_related_products_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/related-products/related-products.component */ "./src/app/shared/components/related-products/related-products.component.ts");
/* harmony import */ var _components_reviews_reviews_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/reviews/reviews.component */ "./src/app/shared/components/reviews/reviews.component.ts");
/* harmony import */ var angular_star_rating__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! angular-star-rating */ "./node_modules/angular-star-rating/esm2015/angular-star-rating.js");
/* harmony import */ var _components_product_price_product_price_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/product-price/product-price.component */ "./src/app/shared/components/product-price/product-price.component.ts");
/* harmony import */ var _components_product_options_product_options_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./components/product-options/product-options.component */ "./src/app/shared/components/product-options/product-options.component.ts");
/* harmony import */ var _components_order_summary_order_summary_component__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./components/order-summary/order-summary.component */ "./src/app/shared/components/order-summary/order-summary.component.ts");
/* harmony import */ var _components_review_address_review_address_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/review-address/review-address.component */ "./src/app/shared/components/review-address/review-address.component.ts");
/* harmony import */ var _pipes_format_date_pipe__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./pipes/format-date.pipe */ "./src/app/shared/pipes/format-date.pipe.ts");
/* harmony import */ var _pipes_sanitize_html_pipe__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./pipes/sanitize-html.pipe */ "./src/app/shared/pipes/sanitize-html.pipe.ts");
/* harmony import */ var _components_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./components/not-found/not-found.component */ "./src/app/shared/components/not-found/not-found.component.ts");
/* harmony import */ var _directives_expand_lists_directive__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./directives/expand-lists.directive */ "./src/app/shared/directives/expand-lists.directive.ts");





































let SharedModule = class SharedModule {
};
SharedModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _header_header_component__WEBPACK_IMPORTED_MODULE_3__["HeaderComponent"],
            _footer_footer_component__WEBPACK_IMPORTED_MODULE_4__["FooterComponent"],
            _side_nav_side_nav_component__WEBPACK_IMPORTED_MODULE_5__["SideNavComponent"],
            _components_category_category_component__WEBPACK_IMPORTED_MODULE_7__["CategoryComponent"],
            _pipes_image_url_pipe__WEBPACK_IMPORTED_MODULE_8__["ImageUrlPipe"],
            _components_perk_perk_component__WEBPACK_IMPORTED_MODULE_9__["PerkComponent"],
            _components_team_team_component__WEBPACK_IMPORTED_MODULE_10__["TeamComponent"],
            _components_contact_form_contact_form_component__WEBPACK_IMPORTED_MODULE_12__["ContactFormComponent"], _components_faq_faq_component__WEBPACK_IMPORTED_MODULE_14__["FaqComponent"], _components_sidebar_menu_sidebar_menu_component__WEBPACK_IMPORTED_MODULE_15__["SidebarMenuComponent"],
            _components_recent_blogs_recent_blogs_component__WEBPACK_IMPORTED_MODULE_16__["RecentBlogsComponent"], _components_subscribe_subscribe_component__WEBPACK_IMPORTED_MODULE_17__["SubscribeComponent"], _components_login_popup_login_popup_component__WEBPACK_IMPORTED_MODULE_18__["LoginPopupComponent"], _components_forgot_password_forgot_password_component__WEBPACK_IMPORTED_MODULE_21__["ForgotPasswordComponent"],
            _pipes_excerpt_pipe__WEBPACK_IMPORTED_MODULE_22__["ExcerptPipe"], _components_product_filters_product_filters_component__WEBPACK_IMPORTED_MODULE_23__["ProductFiltersComponent"], _pipes_safe_html_pipe__WEBPACK_IMPORTED_MODULE_24__["SafeHtmlPipe"], _components_login_form_login_form_component__WEBPACK_IMPORTED_MODULE_25__["LoginFormComponent"], _components_related_products_related_products_component__WEBPACK_IMPORTED_MODULE_26__["RelatedProductsComponent"],
            _components_reviews_reviews_component__WEBPACK_IMPORTED_MODULE_27__["ReviewsComponent"], _components_product_price_product_price_component__WEBPACK_IMPORTED_MODULE_29__["ProductPriceComponent"], _components_product_options_product_options_component__WEBPACK_IMPORTED_MODULE_30__["ProductOptionsComponent"], _components_order_summary_order_summary_component__WEBPACK_IMPORTED_MODULE_31__["OrderSummaryComponent"], _components_review_address_review_address_component__WEBPACK_IMPORTED_MODULE_32__["ReviewAddressComponent"],
            _pipes_format_date_pipe__WEBPACK_IMPORTED_MODULE_33__["FormatDatePipe"],
            _pipes_sanitize_html_pipe__WEBPACK_IMPORTED_MODULE_34__["SanitizeHTMLPipe"], _components_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_35__["NotFoundComponent"], _directives_expand_lists_directive__WEBPACK_IMPORTED_MODULE_36__["ExpandListsDirective"]
        ],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_6__["RouterModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_13__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_13__["ReactiveFormsModule"],
            angular_star_rating__WEBPACK_IMPORTED_MODULE_28__["StarRatingModule"].forRoot()
        ],
        exports: [
            _header_header_component__WEBPACK_IMPORTED_MODULE_3__["HeaderComponent"],
            _footer_footer_component__WEBPACK_IMPORTED_MODULE_4__["FooterComponent"],
            _side_nav_side_nav_component__WEBPACK_IMPORTED_MODULE_5__["SideNavComponent"],
            _components_category_category_component__WEBPACK_IMPORTED_MODULE_7__["CategoryComponent"],
            _pipes_image_url_pipe__WEBPACK_IMPORTED_MODULE_8__["ImageUrlPipe"],
            _components_perk_perk_component__WEBPACK_IMPORTED_MODULE_9__["PerkComponent"],
            _components_team_team_component__WEBPACK_IMPORTED_MODULE_10__["TeamComponent"],
            _components_contact_form_contact_form_component__WEBPACK_IMPORTED_MODULE_12__["ContactFormComponent"],
            _components_faq_faq_component__WEBPACK_IMPORTED_MODULE_14__["FaqComponent"],
            _components_sidebar_menu_sidebar_menu_component__WEBPACK_IMPORTED_MODULE_15__["SidebarMenuComponent"],
            _components_recent_blogs_recent_blogs_component__WEBPACK_IMPORTED_MODULE_16__["RecentBlogsComponent"],
            _components_subscribe_subscribe_component__WEBPACK_IMPORTED_MODULE_17__["SubscribeComponent"],
            _components_login_popup_login_popup_component__WEBPACK_IMPORTED_MODULE_18__["LoginPopupComponent"],
            _components_forgot_password_forgot_password_component__WEBPACK_IMPORTED_MODULE_21__["ForgotPasswordComponent"],
            _pipes_excerpt_pipe__WEBPACK_IMPORTED_MODULE_22__["ExcerptPipe"],
            _components_product_filters_product_filters_component__WEBPACK_IMPORTED_MODULE_23__["ProductFiltersComponent"],
            _pipes_safe_html_pipe__WEBPACK_IMPORTED_MODULE_24__["SafeHtmlPipe"],
            _components_login_form_login_form_component__WEBPACK_IMPORTED_MODULE_25__["LoginFormComponent"],
            _components_related_products_related_products_component__WEBPACK_IMPORTED_MODULE_26__["RelatedProductsComponent"],
            _components_reviews_reviews_component__WEBPACK_IMPORTED_MODULE_27__["ReviewsComponent"],
            _components_product_price_product_price_component__WEBPACK_IMPORTED_MODULE_29__["ProductPriceComponent"],
            _components_product_options_product_options_component__WEBPACK_IMPORTED_MODULE_30__["ProductOptionsComponent"],
            _components_order_summary_order_summary_component__WEBPACK_IMPORTED_MODULE_31__["OrderSummaryComponent"],
            _components_review_address_review_address_component__WEBPACK_IMPORTED_MODULE_32__["ReviewAddressComponent"],
            _pipes_format_date_pipe__WEBPACK_IMPORTED_MODULE_33__["FormatDatePipe"],
            _pipes_sanitize_html_pipe__WEBPACK_IMPORTED_MODULE_34__["SanitizeHTMLPipe"],
            _components_not_found_not_found_component__WEBPACK_IMPORTED_MODULE_35__["NotFoundComponent"],
            _directives_expand_lists_directive__WEBPACK_IMPORTED_MODULE_36__["ExpandListsDirective"]
        ],
        providers: [
            _pipes_image_url_pipe__WEBPACK_IMPORTED_MODULE_8__["ImageUrlPipe"],
            _libs_localstorage__WEBPACK_IMPORTED_MODULE_11__["LocalStorage"],
            _auth_auth_service___WEBPACK_IMPORTED_MODULE_19__["AuthService"],
            _auth_auth_guard_service__WEBPACK_IMPORTED_MODULE_20__["AuthGuardService"],
            _pipes_excerpt_pipe__WEBPACK_IMPORTED_MODULE_22__["ExcerptPipe"],
        ]
    })
], SharedModule);



/***/ }),

/***/ "./src/app/shared/side-nav/side-nav.component.css":
/*!********************************************************!*\
  !*** ./src/app/shared/side-nav/side-nav.component.css ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9zaWRlLW5hdi9zaWRlLW5hdi5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/shared/side-nav/side-nav.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/shared/side-nav/side-nav.component.ts ***!
  \*******************************************************/
/*! exports provided: SideNavComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SideNavComponent", function() { return SideNavComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../api.service */ "./src/app/shared/api.service.ts");
/* harmony import */ var _services_helper_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../services/helper.service */ "./src/app/shared/services/helper.service.ts");




let SideNavComponent = class SideNavComponent {
    constructor(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.categories = [];
    }
    ngOnInit() {
        this.getPagesMenu();
        this.getCategories();
    }
    getCategories() {
        this.apiService.productCategories().subscribe(res => {
            this.categories = res.result;
        }, err => {
            console.log('err', err);
        });
    }
    getPagesMenu() {
        this.apiService.getPagesMenu().subscribe(res => {
            this.pagesMenu = res.result;
        });
    }
};
SideNavComponent.ctorParameters = () => [
    { type: _api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] },
    { type: _services_helper_service__WEBPACK_IMPORTED_MODULE_3__["HelperService"] }
];
SideNavComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-side-nav',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./side-nav.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/side-nav/side-nav.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./side-nav.component.css */ "./src/app/shared/side-nav/side-nav.component.css")).default]
    })
], SideNavComponent);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

//  const BASE_URL = 'kadmin.dotlogicstest.com';
// const BASE_URL = 'http://localhost:8000/';
const BASE_URL = 'https://kadmin.dotlogicstest.com/';
const environment = {
    production: false,
    site360_siteId: 'ka.dotlogicstest.com',
    base_url: BASE_URL,
    apiUrl: BASE_URL + 'api/',
    storageUrl: BASE_URL + 'storage/'
};


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
document.addEventListener('DOMContentLoaded', () => {
    Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
        .catch(err => console.error(err));
});


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /app/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map